export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  GraphbackDateTime: any;
};

/**
 * @db(name: 'accessorials')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Accessorial = Node & {
  __typename?: 'Accessorial';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @oneToMany(field: 'accessorial', key: 'accessorial_id') */
  ltl_load_spec_templates: Array<AccessorialsLtlLoadSpecTemplates>;
  /** @oneToMany(field: 'accessorial', key: 'accessorial_id') */
  ltl_load_specs: Array<AccessorialsLtlLoadSpecs>;
  name: Scalars['String'];
  type?: Maybe<AccessorialType>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};


/**
 * @db(name: 'accessorials')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AccessorialLtl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecTemplatesFilter>;
};


/**
 * @db(name: 'accessorials')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AccessorialLtl_Load_SpecsArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecsFilter>;
};

export type AccessorialFilter = {
  and?: InputMaybe<Array<AccessorialFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<AccessorialFilter>;
  or?: InputMaybe<Array<AccessorialFilter>>;
  type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type AccessorialResultList = {
  __typename?: 'AccessorialResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Accessorial>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum AccessorialType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

/**
 * @db(name: 'accessorials_ltl_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AccessorialsLtlLoadSpecTemplates = {
  __typename?: 'AccessorialsLtlLoadSpecTemplates';
  /**
   * @manyToOne(field: 'ltl_load_spec_templates', key: 'accessorial_id')
   * @unique(name: 'accessorial_ltl_load_spec_template_unique')
   */
  accessorial: Accessorial;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /**
   * @manyToOne(field: 'accessorials', key: 'ltl_load_spec_template_id')
   * @unique(name: 'accessorial_ltl_load_spec_template_unique')
   */
  ltl_load_spec_template: LtlLoadSpecTemplate;
  /**
   * @manyToOne(field: 'accessorials_ltl_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type AccessorialsLtlLoadSpecTemplatesFilter = {
  accessorial_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<AccessorialsLtlLoadSpecTemplatesFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  ltl_load_spec_template_id?: InputMaybe<IdInput>;
  not?: InputMaybe<AccessorialsLtlLoadSpecTemplatesFilter>;
  or?: InputMaybe<Array<AccessorialsLtlLoadSpecTemplatesFilter>>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @db(name: 'accessorials_ltl_load_specs')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AccessorialsLtlLoadSpecs = {
  __typename?: 'AccessorialsLtlLoadSpecs';
  /**
   * @manyToOne(field: 'ltl_load_specs', key: 'accessorial_id')
   * @unique(name: 'accessorial_ltl_load_spec_unique')
   */
  accessorial: Accessorial;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /**
   * @manyToOne(field: 'accessorials', key: 'ltl_load_spec_id')
   * @unique(name: 'accessorial_ltl_load_spec_unique')
   */
  ltl_load_spec: LtlLoadSpec;
  /**
   * @manyToOne(field: 'accessorials_ltl_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type AccessorialsLtlLoadSpecsFilter = {
  accessorial_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<AccessorialsLtlLoadSpecsFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  ltl_load_spec_id?: InputMaybe<IdInput>;
  not?: InputMaybe<AccessorialsLtlLoadSpecsFilter>;
  or?: InputMaybe<Array<AccessorialsLtlLoadSpecsFilter>>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Address = Node & SoftDeletable & {
  __typename?: 'Address';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'address', key: 'address_id') */
  address_contacts: Array<AddressContact>;
  /** @oneToMany(field: 'destination_airport', key: 'destination_airport_id') */
  air_quotes_destination: Array<AirQuote>;
  /** @oneToMany(field: 'origin_airport', key: 'origin_airport_id') */
  air_quotes_origin: Array<AirQuote>;
  /** @oneToMany(field: 'via_airport', key: 'via_airport_id') */
  air_quotes_via: Array<AirQuote>;
  airport_iata_code?: Maybe<Scalars['String']>;
  airport_id?: Maybe<Scalars['String']>;
  airport_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  country_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @index */
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'deleted_addresses', key: 'deleted_by_id') */
  deleted_by?: Maybe<User>;
  /** @oneToMany(field: 'destination_port', key: 'destination_port_id') */
  fcl_quotes_destination: Array<FclQuote>;
  /** @oneToMany(field: 'destination_rail_ramp', key: 'destination_rail_ramp_id') */
  fcl_quotes_destination_rail_ramp: Array<FclQuote>;
  /** @oneToMany(field: 'origin_port', key: 'origin_port_id') */
  fcl_quotes_origin: Array<FclQuote>;
  /** @oneToMany(field: 'via_port', key: 'via_port_id') */
  fcl_quotes_via: Array<FclQuote>;
  /** @transient */
  formatted_long_name: Scalars['String'];
  /** @transient */
  formatted_short_name: Scalars['String'];
  /**
   * @summary This is the user-selected google places suggestion description: (see: google.maps.places.AutocompletePrediction)
   * @description This is exactly what the user saw when they clicked the option provided by google places autocomplete suggestions based on their search.
   * This is most useful for international addresses where the formatted address on the place result may be very different from the user selection on search.
   * @see https://developers.google.com/maps/documentation/places/web-service/autocomplete#PlaceAutocompletePrediction-description
   */
  google_place_description?: Maybe<Scalars['String']>;
  google_place_id?: Maybe<Scalars['String']>;
  hours_end?: Maybe<Scalars['GraphbackDateTime']>;
  hours_start?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  iana_timezone: Scalars['String'];
  id: Scalars['ID'];
  /** @default(value: false) */
  is_created_by_broker?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  port_id?: Maybe<Scalars['String']>;
  port_name?: Maybe<Scalars['String']>;
  province_code?: Maybe<Scalars['String']>;
  province_name?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'addresses', key: 'shipper_id')
   * @index
   */
  shipper?: Maybe<Shipper>;
  /** @oneToMany(field: 'address', key: 'address_id') */
  stop_templates: Array<StopTemplate>;
  /** @oneToMany(field: 'address', key: 'address_id') */
  stops: Array<Stop>;
  /**
   * @db(type: 'text')
   * @default(value: 'UNKNOWN')
   */
  type: AddressType;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  zip?: Maybe<Scalars['String']>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressAddress_ContactsArgs = {
  filter?: InputMaybe<AddressContactFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressAir_Quotes_DestinationArgs = {
  filter?: InputMaybe<AirQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressAir_Quotes_OriginArgs = {
  filter?: InputMaybe<AirQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressAir_Quotes_ViaArgs = {
  filter?: InputMaybe<AirQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressFcl_Quotes_DestinationArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressFcl_Quotes_Destination_Rail_RampArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressFcl_Quotes_OriginArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressFcl_Quotes_ViaArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressStop_TemplatesArgs = {
  filter?: InputMaybe<StopTemplateFilter>;
};


/**
 * @db(name: 'addresses')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressStopsArgs = {
  filter?: InputMaybe<StopFilter>;
};

/**
 * @db(name: 'address_contacts')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AddressContact = Node & {
  __typename?: 'AddressContact';
  /**
   * @manyToOne(field: 'address_contacts', key: 'address_id')
   * @index
   */
  address: Address;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'address_contacts', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type AddressContactFilter = {
  address_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<AddressContactFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  email?: InputMaybe<StringInput>;
  first_name?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  last_name?: InputMaybe<StringInput>;
  not?: InputMaybe<AddressContactFilter>;
  or?: InputMaybe<Array<AddressContactFilter>>;
  phone_number?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type AddressContactPayload = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
};

export type AddressFilter = {
  address_1?: InputMaybe<StringInput>;
  address_2?: InputMaybe<StringInput>;
  airport_iata_code?: InputMaybe<StringInput>;
  airport_id?: InputMaybe<StringInput>;
  airport_name?: InputMaybe<StringInput>;
  and?: InputMaybe<Array<AddressFilter>>;
  city?: InputMaybe<StringInput>;
  country_code?: InputMaybe<StringInput>;
  country_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_by_id?: InputMaybe<IdInput>;
  google_place_description?: InputMaybe<StringInput>;
  google_place_id?: InputMaybe<StringInput>;
  hours_end?: InputMaybe<GraphbackDateTimeInput>;
  hours_start?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  is_created_by_broker?: InputMaybe<BooleanInput>;
  lat?: InputMaybe<StringInput>;
  lon?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<AddressFilter>;
  or?: InputMaybe<Array<AddressFilter>>;
  phone_number?: InputMaybe<StringInput>;
  port_id?: InputMaybe<StringInput>;
  port_name?: InputMaybe<StringInput>;
  province_code?: InputMaybe<StringInput>;
  province_name?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  zip?: InputMaybe<StringInput>;
};

export type AddressResultList = {
  __typename?: 'AddressResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Address>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum AddressType {
  Airport = 'AIRPORT',
  Street = 'STREET',
  Railhead = 'RAILHEAD',
  Seaport = 'SEAPORT',
  Unknown = 'UNKNOWN'
}

/** Incoterms specific to Mode.AIR */
export enum AirIncoterms {
  Cip = 'CIP',
  Cpt = 'CPT',
  Dap = 'DAP',
  Ddp = 'DDP',
  Dpu = 'DPU',
  Exw = 'EXW',
  Fca = 'FCA',
  Fob = 'FOB'
}

/**
 * @db(name: 'air_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirLoadSpec = Node & {
  __typename?: 'AirLoadSpec';
  cargo_ready_date?: Maybe<Scalars['GraphbackDateTime']>;
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  include_customs_clearance?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  incoterms?: Maybe<AirIncoterms>;
  /** @default(value: false) */
  is_overweight?: Maybe<Scalars['Boolean']>;
  item_quantity?: Maybe<Scalars['Int']>;
  length_per_package?: Maybe<Scalars['Float']>;
  /** @oneToMany(field: 'air_load_spec', key: 'air_load_spec_id') */
  package_groups: Array<AirPackageGroup>;
  /**
   * @index
   * @oneToOne(field: 'quote_request', key: 'quote_request_id')
   */
  quote_request: QuoteRequest;
  /** @db(type: 'text') */
  routing_type?: Maybe<RoutingType>;
  /**
   * @db(type: 'json')
   * @default(value: [])
   */
  service_levels: Array<ServiceLevel>;
  /**
   * @manyToOne(field: 'air_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  target_delivery_date?: Maybe<Scalars['GraphbackDateTime']>;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_volume?: Maybe<Scalars['Float']>;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'DIMENSIONS')
   */
  volume_format?: Maybe<VolumeFormat>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
  width_per_package?: Maybe<Scalars['Float']>;
};


/**
 * @db(name: 'air_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirLoadSpecPackage_GroupsArgs = {
  filter?: InputMaybe<AirPackageGroupFilter>;
};

export type AirLoadSpecFilter = {
  and?: InputMaybe<Array<AirLoadSpecFilter>>;
  cargo_ready_date?: InputMaybe<GraphbackDateTimeInput>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  include_customs_clearance?: InputMaybe<BooleanInput>;
  incoterms?: InputMaybe<StringInput>;
  is_overweight?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  not?: InputMaybe<AirLoadSpecFilter>;
  or?: InputMaybe<Array<AirLoadSpecFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  routing_type?: InputMaybe<StringInput>;
  service_levels?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  target_delivery_date?: InputMaybe<GraphbackDateTimeInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_volume?: InputMaybe<FloatInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume_format?: InputMaybe<StringInput>;
  weight_unit?: InputMaybe<StringInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

/**
 * @db(name: 'air_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirLoadSpecTemplate = Node & {
  __typename?: 'AirLoadSpecTemplate';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  include_customs_clearance?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  incoterms?: Maybe<AirIncoterms>;
  /** @default(value: false) */
  is_overweight?: Maybe<Scalars['Boolean']>;
  item_quantity?: Maybe<Scalars['Int']>;
  length_per_package?: Maybe<Scalars['Float']>;
  /** @oneToMany(field: 'air_load_spec_template', key: 'air_load_spec_template_id') */
  package_group_templates: Array<AirPackageGroupTemplate>;
  /**
   * @index
   * @oneToOne(field: 'quote_request_template', key: 'quote_request_template_id')
   */
  quote_request_template: QuoteRequestTemplate;
  /** @db(type: 'text') */
  routing_type?: Maybe<RoutingType>;
  /**
   * @db(type: 'json')
   * @default(value: [])
   */
  service_levels: Array<ServiceLevel>;
  /**
   * @manyToOne(field: 'air_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_volume?: Maybe<Scalars['Float']>;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'DIMENSIONS')
   */
  volume_format?: Maybe<VolumeFormat>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
  width_per_package?: Maybe<Scalars['Float']>;
};


/**
 * @db(name: 'air_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirLoadSpecTemplatePackage_Group_TemplatesArgs = {
  filter?: InputMaybe<AirPackageGroupTemplateFilter>;
};

export type AirLoadSpecTemplateFilter = {
  and?: InputMaybe<Array<AirLoadSpecTemplateFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  include_customs_clearance?: InputMaybe<BooleanInput>;
  incoterms?: InputMaybe<StringInput>;
  is_overweight?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  not?: InputMaybe<AirLoadSpecTemplateFilter>;
  or?: InputMaybe<Array<AirLoadSpecTemplateFilter>>;
  quote_request_template_id?: InputMaybe<IdInput>;
  routing_type?: InputMaybe<StringInput>;
  service_levels?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_volume?: InputMaybe<FloatInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume_format?: InputMaybe<StringInput>;
  weight_unit?: InputMaybe<StringInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

/**
 * @db(name: 'air_package_groups')
 * @model(create: true, find: false, findOne: false, update: true, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirPackageGroup = Node & {
  __typename?: 'AirPackageGroup';
  /**
   * @manyToOne(field: 'package_groups', key: 'air_load_spec_id')
   * @index
   */
  air_load_spec: AirLoadSpec;
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  /** @default(value: 1) */
  item_quantity: Scalars['Int'];
  length_per_package?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  packaging_type: PackagingType;
  /**
   * @manyToOne(field: 'air_package_groups', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'VOLUME')
   */
  volume_format: VolumeFormat;
  volume_per_item?: Maybe<Scalars['Float']>;
  weight_per_package: Scalars['Float'];
  width_per_package?: Maybe<Scalars['Float']>;
};

export type AirPackageGroupFilter = {
  air_load_spec_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<AirPackageGroupFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  not?: InputMaybe<AirPackageGroupFilter>;
  or?: InputMaybe<Array<AirPackageGroupFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume_format?: InputMaybe<StringInput>;
  volume_per_item?: InputMaybe<FloatInput>;
  weight_per_package?: InputMaybe<FloatInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

export type AirPackageGroupPayload = {
  height_per_package?: InputMaybe<Scalars['Float']>;
  item_quantity: Scalars['Int'];
  length_per_package?: InputMaybe<Scalars['Float']>;
  packaging_type: PackagingType;
  volume_format: VolumeFormat;
  volume_per_item?: InputMaybe<Scalars['Float']>;
  weight_per_package: Scalars['Float'];
  width_per_package?: InputMaybe<Scalars['Float']>;
};

/**
 * @db(name: 'air_package_group_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirPackageGroupTemplate = Node & {
  __typename?: 'AirPackageGroupTemplate';
  /**
   * @manyToOne(field: 'package_group_templates', key: 'air_load_spec_template_id')
   * @index
   */
  air_load_spec_template: AirLoadSpecTemplate;
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  /** @default(value: 1) */
  item_quantity: Scalars['Int'];
  length_per_package?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  packaging_type: PackagingType;
  /**
   * @manyToOne(field: 'air_package_group_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'VOLUME')
   */
  volume_format: VolumeFormat;
  volume_per_item?: Maybe<Scalars['Float']>;
  weight_per_package: Scalars['Float'];
  width_per_package?: Maybe<Scalars['Float']>;
};

export type AirPackageGroupTemplateFilter = {
  air_load_spec_template_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<AirPackageGroupTemplateFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  not?: InputMaybe<AirPackageGroupTemplateFilter>;
  or?: InputMaybe<Array<AirPackageGroupTemplateFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume_format?: InputMaybe<StringInput>;
  volume_per_item?: InputMaybe<FloatInput>;
  weight_per_package?: InputMaybe<FloatInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

/**
 * @db(name: 'air_quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirQuote = Node & {
  __typename?: 'AirQuote';
  /** @db(type: 'text') */
  booking_notes?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  /** @transient */
  chargeable_weight: Scalars['Float'];
  company_name?: Maybe<Scalars['String']>;
  /** @transient */
  conversation_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'air_quotes_destination', key: 'destination_airport_id') */
  destination_airport: Address;
  dim_factor: Scalars['Float'];
  id: Scalars['ID'];
  /** @oneToOne(field: 'load', key: 'load_id') */
  load?: Maybe<Load>;
  max_transit_time?: Maybe<Scalars['Int']>;
  min_transit_time?: Maybe<Scalars['Int']>;
  /** @db(type: 'text') */
  notes?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  notes_charges_insurance?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  notes_charges_miscellaneous?: Maybe<Scalars['String']>;
  /** @manyToOne(field: 'air_quotes_origin', key: 'origin_airport_id') */
  origin_airport: Address;
  /** @oneToMany(field: 'quote', key: 'quote_id') */
  quote_charges: Array<AirQuoteCharge>;
  /** @transient */
  quote_charges_totals: QuoteChargeTotals;
  /**
   * @manyToOne(field: 'air_quotes', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  rate_per_kg?: Maybe<Scalars['Float']>;
  service_level: ServiceLevel;
  /**
   * @manyToOne(field: 'air_quotes', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /**
   * @db(type: 'text')
   * @default(value: 'DRAFT')
   */
  status: QuoteStatus;
  submitter_email: Scalars['String'];
  submitter_tz?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  valid_until: Scalars['GraphbackDateTime'];
  /** @manyToOne(field: 'air_quotes_via', key: 'via_airport_id') */
  via_airport?: Maybe<Address>;
  volumetric_weight: Scalars['Float'];
};


/**
 * @db(name: 'air_quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirQuoteQuote_ChargesArgs = {
  filter?: InputMaybe<AirQuoteChargeFilter>;
};

export type AirQuoteAirportPayload = {
  airport_iata_code?: InputMaybe<Scalars['String']>;
  airport_id?: InputMaybe<Scalars['String']>;
  airport_name?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  country_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  province_code?: InputMaybe<Scalars['String']>;
  province_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
};

/**
 * @db(name: 'air_quote_charges')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type AirQuoteCharge = Node & {
  __typename?: 'AirQuoteCharge';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  item_quantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** item quantity * weight */
  quantity: Scalars['Float'];
  /**
   * @manyToOne(field: 'quote_charges', key: 'quote_id')
   * @index
   */
  quote: AirQuote;
  /**
   * @manyToOne(field: 'air_quote_charges', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  rate: Scalars['Float'];
  /**
   * @manyToOne(field: 'air_quote_charges', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  type: ChargeType;
  unit: ChargeUnitType;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type AirQuoteChargeFilter = {
  and?: InputMaybe<Array<AirQuoteChargeFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  item_quantity?: InputMaybe<IntInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<AirQuoteChargeFilter>;
  or?: InputMaybe<Array<AirQuoteChargeFilter>>;
  quantity?: InputMaybe<FloatInput>;
  quote_id?: InputMaybe<IdInput>;
  quote_request_id?: InputMaybe<IdInput>;
  rate?: InputMaybe<FloatInput>;
  shipper_id?: InputMaybe<IdInput>;
  type?: InputMaybe<StringInput>;
  unit?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type AirQuoteChargePayload = {
  item_quantity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  /** item quantity * weight */
  quantity: Scalars['Float'];
  rate: Scalars['Float'];
  type: ChargeType;
  unit: ChargeUnitType;
};

export type AirQuoteFilter = {
  and?: InputMaybe<Array<AirQuoteFilter>>;
  booking_notes?: InputMaybe<StringInput>;
  carrier?: InputMaybe<StringInput>;
  company_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  destination_airport_id?: InputMaybe<IdInput>;
  dim_factor?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  load_id?: InputMaybe<IdInput>;
  max_transit_time?: InputMaybe<IntInput>;
  min_transit_time?: InputMaybe<IntInput>;
  not?: InputMaybe<AirQuoteFilter>;
  notes?: InputMaybe<StringInput>;
  notes_charges_insurance?: InputMaybe<StringInput>;
  notes_charges_miscellaneous?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<AirQuoteFilter>>;
  origin_airport_id?: InputMaybe<IdInput>;
  quote_request_id?: InputMaybe<IdInput>;
  rate_per_kg?: InputMaybe<FloatInput>;
  service_level?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  status?: InputMaybe<StringInput>;
  submitter_email?: InputMaybe<StringInput>;
  submitter_tz?: InputMaybe<StringInput>;
  total_amount?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  valid_until?: InputMaybe<GraphbackDateTimeInput>;
  via_airport_id?: InputMaybe<IdInput>;
  volumetric_weight?: InputMaybe<FloatInput>;
};

export type AirQuoteTotals = {
  __typename?: 'AirQuoteTotals';
  rate_per_kg: Scalars['Float'];
  total_amount: Scalars['Float'];
};

/**
 * @db(name: 'airports')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Airport = Node & {
  __typename?: 'Airport';
  city: Scalars['String'];
  country_code: Scalars['String'];
  country_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  iana_timezone: Scalars['String'];
  iata_code: Scalars['String'];
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  lowercase_iata_code: Scalars['String'];
  lowercase_name: Scalars['String'];
  name: Scalars['String'];
  province_code: Scalars['String'];
  province_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type AirportFilter = {
  and?: InputMaybe<Array<AirportFilter>>;
  city?: InputMaybe<StringInput>;
  country_code?: InputMaybe<StringInput>;
  country_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  iata_code?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  lat?: InputMaybe<StringInput>;
  lon?: InputMaybe<StringInput>;
  lowercase_iata_code?: InputMaybe<StringInput>;
  lowercase_name?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<AirportFilter>;
  or?: InputMaybe<Array<AirportFilter>>;
  province_code?: InputMaybe<StringInput>;
  province_name?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type AirportResultList = {
  __typename?: 'AirportResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Airport>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type BookQuoteInput = {
  booking_notes?: InputMaybe<Scalars['String']>;
  quote_id: Scalars['String'];
  quote_request_id: Scalars['ID'];
};

export type BooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type CancelQuoteRequestInput = {
  id: Scalars['ID'];
  /** @description user input reason for canceling the shipment. Optional and can be empty */
  reason?: InputMaybe<Scalars['String']>;
};

export type CargoDetailsAir = {
  perPackageHeight?: InputMaybe<Scalars['Float']>;
  perPackageLength?: InputMaybe<Scalars['Float']>;
  perPackageWidth?: InputMaybe<Scalars['Float']>;
  totalItems: Scalars['Int'];
  totalVolume?: InputMaybe<Scalars['Float']>;
  totalWeight: Scalars['Float'];
  volumeFormat: VolumeFormat;
};

export enum ChargeType {
  Customs = 'CUSTOMS',
  Destination = 'DESTINATION',
  Freight = 'FREIGHT',
  Insurance = 'INSURANCE',
  Origin = 'ORIGIN'
}

export enum ChargeUnitType {
  Container = 'CONTAINER',
  Kg = 'KG',
  Shipment = 'SHIPMENT'
}

export type CloseQuoteRequestInput = {
  id: Scalars['ID'];
  other_reason?: InputMaybe<Scalars['String']>;
  reason: CloseQuoteRequestReason;
  send_notification?: InputMaybe<Scalars['Boolean']>;
};

export enum CloseQuoteRequestReason {
  BookedOffPlatform = 'BOOKED_OFF_PLATFORM',
  Other = 'OTHER'
}

export type Company = {
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @index */
  name: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export enum CompanyType {
  Shipper = 'SHIPPER'
}

/**
 * @db(name: 'contacts')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Contact = Node & SoftDeletable & {
  __typename?: 'Contact';
  city?: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @index */
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'deleted_contacts', key: 'deleted_by_id') */
  deleted_by?: Maybe<User>;
  /** @manyToOne(field: 'contacts', key: 'user_id') */
  user: User;
  /** @default(value: false) */
  is_from_chat: Scalars['Boolean'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_internal?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'contact', key: 'contact_id') */
  quote_requests: Array<ContactsQuoteRequests>;
  /**
   * @manyToOne(field: 'contacts', key: 'shipper_id')
   * @index
   */
  shipper?: Maybe<Shipper>;
  state?: Maybe<Scalars['String']>;
  /** @transient */
  tags: Array<Tag>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};


/**
 * @db(name: 'contacts')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ContactQuote_RequestsArgs = {
  filter?: InputMaybe<ContactsQuoteRequestsFilter>;
};

export type ContactFilter = {
  and?: InputMaybe<Array<ContactFilter>>;
  city?: InputMaybe<StringInput>;
  company_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_by_id?: InputMaybe<IdInput>;
  email?: InputMaybe<StringInput>;
  first_name?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  is_internal?: InputMaybe<BooleanInput>;
  last_name?: InputMaybe<StringInput>;
  not?: InputMaybe<ContactFilter>;
  or?: InputMaybe<Array<ContactFilter>>;
  phone_number?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  state?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  user_id?: InputMaybe<IdInput>;
};

export type ContactResultList = {
  __typename?: 'ContactResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Contact>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/**
 * @db(name: 'contacts_quote_requests')
 * @model(create: true, find: true, findOne: false, update: false, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ContactsQuoteRequests = {
  __typename?: 'ContactsQuoteRequests';
  /**
   * @manyToOne(field: 'quote_requests', key: 'contact_id')
   * @index
   * @unique(name: 'contact_quote_request_unique')
   */
  contact: Contact;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /**
   * @manyToOne(field: 'recipients', key: 'quote_request_id')
   * @index
   * @unique(name: 'contact_quote_request_unique')
   */
  quote_request: QuoteRequest;
  /**
   * @manyToOne(field: 'contacts_quote_requests', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type ContactsQuoteRequestsFilter = {
  and?: InputMaybe<Array<ContactsQuoteRequestsFilter>>;
  contact_id?: InputMaybe<IdInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  not?: InputMaybe<ContactsQuoteRequestsFilter>;
  or?: InputMaybe<Array<ContactsQuoteRequestsFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type ContactsQuoteRequestsResultList = {
  __typename?: 'ContactsQuoteRequestsResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<ContactsQuoteRequests>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/**
 * @db(name: 'containers')
 * @model(create: true, find: false, findOne: false, update: true, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Container = Node & {
  __typename?: 'Container';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'containers', key: 'fcl_load_spec_id')
   * @index
   */
  fcl_load_spec: FclLoadSpec;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @default(value: false) */
  requires_genset?: Maybe<Scalars['Boolean']>;
  /**
   * @manyToOne(field: 'containers', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @db(type: 'text') */
  size?: Maybe<ContainerSize>;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  /** @db(type: 'text') */
  type?: Maybe<ContainerType>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ContainerFilter = {
  and?: InputMaybe<Array<ContainerFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  fcl_load_spec_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<ContainerFilter>;
  or?: InputMaybe<Array<ContainerFilter>>;
  requires_genset?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  size?: InputMaybe<StringInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume?: InputMaybe<FloatInput>;
  weight?: InputMaybe<FloatInput>;
};

export type ContainerPayload = {
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  requires_genset?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<ContainerSize>;
  type?: InputMaybe<ContainerType>;
  volume?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export enum ContainerSize {
  C_20 = 'C_20',
  C_20Hc = 'C_20_HC',
  C_40 = 'C_40',
  C_40Hc = 'C_40_HC',
  C_45Hc = 'C_45_HC'
}

/**
 * @db(name: 'container_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ContainerTemplate = Node & {
  __typename?: 'ContainerTemplate';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'container_templates', key: 'fcl_load_spec_template_id')
   * @index
   */
  fcl_load_spec_template: FclLoadSpecTemplate;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @default(value: false) */
  requires_genset?: Maybe<Scalars['Boolean']>;
  /**
   * @manyToOne(field: 'container_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @db(type: 'text') */
  size?: Maybe<ContainerSize>;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  /** @db(type: 'text') */
  type?: Maybe<ContainerType>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ContainerTemplateFilter = {
  and?: InputMaybe<Array<ContainerTemplateFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  fcl_load_spec_template_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<ContainerTemplateFilter>;
  or?: InputMaybe<Array<ContainerTemplateFilter>>;
  requires_genset?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  size?: InputMaybe<StringInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  volume?: InputMaybe<FloatInput>;
  weight?: InputMaybe<FloatInput>;
};

export enum ContainerType {
  Dry = 'DRY',
  FlatRack = 'FLAT_RACK',
  OpenTop = 'OPEN_TOP',
  Platform = 'PLATFORM',
  Reefer = 'REEFER'
}

export type CreateAddressInput = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  airport_iata_code?: InputMaybe<Scalars['String']>;
  airport_id?: InputMaybe<Scalars['String']>;
  airport_name?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  country_name?: InputMaybe<Scalars['String']>;
  google_place_description?: InputMaybe<Scalars['String']>;
  google_place_id?: InputMaybe<Scalars['String']>;
  hours_end?: InputMaybe<Scalars['GraphbackDateTime']>;
  hours_start?: InputMaybe<Scalars['GraphbackDateTime']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  port_id?: InputMaybe<Scalars['String']>;
  port_name?: InputMaybe<Scalars['String']>;
  province_code?: InputMaybe<Scalars['String']>;
  province_name?: InputMaybe<Scalars['String']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<AddressType>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateAirPackageGroupInput = {
  air_load_spec_id: Scalars['ID'];
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  hazardous_goods_details?: InputMaybe<Scalars['String']>;
  height_per_package?: InputMaybe<Scalars['Float']>;
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  item_quantity: Scalars['Int'];
  length_per_package?: InputMaybe<Scalars['Float']>;
  packaging_type: PackagingType;
  shipper_id: Scalars['ID'];
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  volume_format: VolumeFormat;
  volume_per_item?: InputMaybe<Scalars['Float']>;
  weight_per_package: Scalars['Float'];
  width_per_package?: InputMaybe<Scalars['Float']>;
};

export type CreateContactInput = {
  city?: InputMaybe<Scalars['String']>;
  company_name: Scalars['String'];
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateContactsQuoteRequestsInput = {
  contact_id: Scalars['ID'];
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  quote_request_id: Scalars['ID'];
  shipper_id: Scalars['ID'];
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type CreateContainerInput = {
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  fcl_load_spec_id: Scalars['ID'];
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  requires_genset?: InputMaybe<Scalars['Boolean']>;
  shipper_id: Scalars['ID'];
  size?: InputMaybe<ContainerSize>;
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  type?: InputMaybe<ContainerType>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  volume?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type CreateDrayageLoadSpecInput = {
  commodities?: InputMaybe<Scalars['String']>;
  container_number?: InputMaybe<Scalars['String']>;
  container_size?: InputMaybe<ContainerSize>;
  container_type?: InputMaybe<ContainerType>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  ocean_bol_number?: InputMaybe<Scalars['String']>;
  quote_request_id: Scalars['ID'];
  requires_genset?: InputMaybe<Scalars['Boolean']>;
  shipper_id: Scalars['ID'];
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  total_weight?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_unit?: InputMaybe<WeightUnit>;
};

export type CreatePackageGroupInput = {
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  dim_unit: DimUnit;
  freight_class?: InputMaybe<FreightClass>;
  hazardous_goods_details?: InputMaybe<Scalars['String']>;
  height_per_package?: InputMaybe<Scalars['Float']>;
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  is_stackable?: InputMaybe<Scalars['Boolean']>;
  item_quantity: Scalars['Int'];
  length_per_package?: InputMaybe<Scalars['Float']>;
  ltl_load_spec_id: Scalars['ID'];
  nmfc_code?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<PackagingType>;
  packing_count?: InputMaybe<Scalars['Int']>;
  pallet_count?: InputMaybe<Scalars['Int']>;
  shipper_id: Scalars['ID'];
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_per_package?: InputMaybe<Scalars['Float']>;
  width_per_package?: InputMaybe<Scalars['Float']>;
};

export type CreatePartnerTagInput = {
  tag: Scalars['String'];
};

export type CreatePreviewPublicQuoteRequestLinkInput = {
  quoteRequestId: Scalars['ID'];
};

export type CreateQuoteRequestFromExistingQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
};

export type CreateQuoteRequestTemplateFromQuoteRequestInput = {
  name?: InputMaybe<Scalars['String']>;
  quoteRequestId: Scalars['ID'];
};

export type CreateQuoteSubmissionLinkInput = {
  quoteRequestId: Scalars['ID'];
};

export type CreateShipperInput = {
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateStopInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  distance_from_prior_stop?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['GraphbackDateTime']>;
  is_na?: InputMaybe<Scalars['Boolean']>;
  is_time_tbd?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  position: Scalars['Int'];
  quote_request_id: Scalars['ID'];
  reference_number?: InputMaybe<Scalars['String']>;
  shipper_id: Scalars['ID'];
  start?: InputMaybe<Scalars['GraphbackDateTime']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type DateCount = {
  __typename?: 'DateCount';
  count: Scalars['Int'];
  date: Scalars['GraphbackDateTime'];
};

export type DeleteAddress = {
  id: Scalars['ID'];
};

export type DeleteContactInput = {
  id: Scalars['ID'];
};

export type DeleteFileInput = {
  id: Scalars['ID'];
};

export enum DimUnit {
  Cm = 'CM',
  In = 'IN'
}

/**
 * @db(name: 'drayage_load_specs')
 * @model(create: true, find: false, findOne: false, update: true, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type DrayageLoadSpec = Node & {
  __typename?: 'DrayageLoadSpec';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  container_number?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  container_size?: Maybe<ContainerSize>;
  /** @db(type: 'text') */
  container_type?: Maybe<ContainerType>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  ocean_bol_number?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'drayage_load_specs', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  /** @default(value: false) */
  requires_genset?: Maybe<Scalars['Boolean']>;
  /**
   * @manyToOne(field: 'drayage_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
};

export type DrayageLoadSpecFilter = {
  and?: InputMaybe<Array<DrayageLoadSpecFilter>>;
  commodities?: InputMaybe<StringInput>;
  container_number?: InputMaybe<StringInput>;
  container_size?: InputMaybe<StringInput>;
  container_type?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<DrayageLoadSpecFilter>;
  ocean_bol_number?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<DrayageLoadSpecFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  requires_genset?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

/**
 * @db(name: 'drayage_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type DrayageLoadSpecTemplate = Node & {
  __typename?: 'DrayageLoadSpecTemplate';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  container_size?: Maybe<ContainerSize>;
  /** @db(type: 'text') */
  container_type?: Maybe<ContainerType>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /**
   * @manyToOne(field: 'drayage_load_spec_templates', key: 'quote_request_template_id')
   * @index
   */
  quote_request_template: QuoteRequestTemplate;
  /** @default(value: false) */
  requires_genset?: Maybe<Scalars['Boolean']>;
  /**
   * @manyToOne(field: 'drayage_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
};

export type DrayageLoadSpecTemplateFilter = {
  and?: InputMaybe<Array<DrayageLoadSpecTemplateFilter>>;
  commodities?: InputMaybe<StringInput>;
  container_size?: InputMaybe<StringInput>;
  container_type?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<DrayageLoadSpecTemplateFilter>;
  or?: InputMaybe<Array<DrayageLoadSpecTemplateFilter>>;
  quote_request_template_id?: InputMaybe<IdInput>;
  requires_genset?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

export enum DriverPreference {
  None = 'NONE',
  Solo = 'SOLO',
  Team = 'TEAM'
}

export enum EquipmentType {
  All = 'ALL',
  BoxTruck = 'BOX_TRUCK',
  Bulk = 'BULK',
  CargoVan = 'CARGO_VAN',
  Conestoga = 'CONESTOGA',
  Drayage = 'DRAYAGE',
  Dry = 'DRY',
  Dump = 'DUMP',
  Flatbed = 'FLATBED',
  FoodGradeTank = 'FOOD_GRADE_TANK',
  Hotshot = 'HOTSHOT',
  NaPartnersChoice = 'NA_PARTNERS_CHOICE',
  Other = 'OTHER',
  PartialLoad = 'PARTIAL_LOAD',
  Reefer = 'REEFER',
  Rgn = 'RGN',
  SprinterVan = 'SPRINTER_VAN',
  StepDeck = 'STEP_DECK'
}

/**
 * @db(name: 'fcl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclLoadSpec = Node & {
  __typename?: 'FclLoadSpec';
  /** @default(value: false) */
  capacity_guarantee_required?: Maybe<Scalars['Boolean']>;
  cargo_ready_date?: Maybe<Scalars['GraphbackDateTime']>;
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'fcl_load_spec', key: 'fcl_load_spec_id') */
  containers: Array<Container>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @default(value: false) */
  direct_sailing_required?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  include_customs_clearance?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  incoterms?: Maybe<OceanIncoterms>;
  /** @default(value: false) */
  is_overweight?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_palletized?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  packing_count?: Maybe<Scalars['Int']>;
  pallet_count?: Maybe<Scalars['Int']>;
  /**
   * @index
   * @oneToOne(field: 'quote_request', key: 'quote_request_id')
   */
  quote_request: QuoteRequest;
  /**
   * @db(type: 'text')
   * @deprecated use `quote_types`.
   */
  quote_type?: Maybe<QuoteType>;
  /**
   * @db(type: 'json')
   * @default(value: [])
   */
  quote_types: Array<QuoteType>;
  /** @db(type: 'text') */
  routing_type?: Maybe<RoutingType>;
  /**
   * @manyToOne(field: 'fcl_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  target_delivery_date?: Maybe<Scalars['GraphbackDateTime']>;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
};


/**
 * @db(name: 'fcl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclLoadSpecContainersArgs = {
  filter?: InputMaybe<ContainerFilter>;
};

export type FclLoadSpecFilter = {
  and?: InputMaybe<Array<FclLoadSpecFilter>>;
  capacity_guarantee_required?: InputMaybe<BooleanInput>;
  cargo_ready_date?: InputMaybe<GraphbackDateTimeInput>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  direct_sailing_required?: InputMaybe<BooleanInput>;
  id?: InputMaybe<IdInput>;
  include_customs_clearance?: InputMaybe<BooleanInput>;
  incoterms?: InputMaybe<StringInput>;
  is_overweight?: InputMaybe<BooleanInput>;
  is_palletized?: InputMaybe<BooleanInput>;
  not?: InputMaybe<FclLoadSpecFilter>;
  or?: InputMaybe<Array<FclLoadSpecFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  packing_count?: InputMaybe<IntInput>;
  pallet_count?: InputMaybe<IntInput>;
  quote_request_id?: InputMaybe<IdInput>;
  quote_type?: InputMaybe<StringInput>;
  quote_types?: InputMaybe<StringInput>;
  routing_type?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  target_delivery_date?: InputMaybe<GraphbackDateTimeInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

/**
 * @db(name: 'fcl_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclLoadSpecTemplate = Node & {
  __typename?: 'FclLoadSpecTemplate';
  /** @default(value: false) */
  capacity_guarantee_required?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'fcl_load_spec_template', key: 'fcl_load_spec_template_id') */
  container_templates: Array<ContainerTemplate>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @default(value: false) */
  direct_sailing_required?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  include_customs_clearance?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  incoterms?: Maybe<OceanIncoterms>;
  /** @default(value: false) */
  is_overweight?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_palletized?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  packing_count?: Maybe<Scalars['Int']>;
  pallet_count?: Maybe<Scalars['Int']>;
  /**
   * @index
   * @oneToOne(field: 'quote_request_template', key: 'quote_request_template_id')
   */
  quote_request_template: QuoteRequestTemplate;
  /**
   * @db(type: 'text')
   * @deprecated use `quote_types`.
   */
  quote_type?: Maybe<QuoteType>;
  /**
   * @db(type: 'json')
   * @default(value: [])
   */
  quote_types: Array<QuoteType>;
  /** @db(type: 'text') */
  routing_type?: Maybe<RoutingType>;
  /**
   * @manyToOne(field: 'fcl_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  total_weight?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'KG')
   */
  weight_unit?: Maybe<WeightUnit>;
};


/**
 * @db(name: 'fcl_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclLoadSpecTemplateContainer_TemplatesArgs = {
  filter?: InputMaybe<ContainerTemplateFilter>;
};

export type FclLoadSpecTemplateFilter = {
  and?: InputMaybe<Array<FclLoadSpecTemplateFilter>>;
  capacity_guarantee_required?: InputMaybe<BooleanInput>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  direct_sailing_required?: InputMaybe<BooleanInput>;
  id?: InputMaybe<IdInput>;
  include_customs_clearance?: InputMaybe<BooleanInput>;
  incoterms?: InputMaybe<StringInput>;
  is_overweight?: InputMaybe<BooleanInput>;
  is_palletized?: InputMaybe<BooleanInput>;
  not?: InputMaybe<FclLoadSpecTemplateFilter>;
  or?: InputMaybe<Array<FclLoadSpecTemplateFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  packing_count?: InputMaybe<IntInput>;
  pallet_count?: InputMaybe<IntInput>;
  quote_request_template_id?: InputMaybe<IdInput>;
  quote_type?: InputMaybe<StringInput>;
  quote_types?: InputMaybe<StringInput>;
  routing_type?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  total_weight?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

/**
 * @db(name: 'fcl_quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclQuote = Node & {
  __typename?: 'FclQuote';
  benchmark?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  booking_notes?: Maybe<Scalars['String']>;
  capacity_guarantee: Scalars['Boolean'];
  carrier?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  /** @transient */
  conversation_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'fcl_quotes_destination', key: 'destination_port_id') */
  destination_port: Address;
  /** @manyToOne(field: 'fcl_quotes_destination_rail_ramp', key: 'destination_rail_ramp_id') */
  destination_rail_ramp?: Maybe<Address>;
  id: Scalars['ID'];
  /** @db(type: 'text') */
  inland_mode_of_transport?: Maybe<InlandModeOfTransportType>;
  /** @oneToOne(field: 'load', key: 'load_id') */
  load?: Maybe<Load>;
  max_transit_time?: Maybe<Scalars['Int']>;
  min_transit_time?: Maybe<Scalars['Int']>;
  /** @db(type: 'text') */
  notes?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  notes_charges_insurance?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  notes_charges_miscellaneous?: Maybe<Scalars['String']>;
  /** @manyToOne(field: 'fcl_quotes_origin', key: 'origin_port_id') */
  origin_port: Address;
  /** @oneToMany(field: 'quote', key: 'quote_id') */
  quote_charges: Array<FclQuoteCharge>;
  /** @transient */
  quote_charges_totals: QuoteChargeTotals;
  /**
   * @manyToOne(field: 'fcl_quotes', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  rate_per_container?: Maybe<Scalars['Float']>;
  /**
   * @manyToOne(field: 'fcl_quotes', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /**
   * @db(type: 'text')
   * @default(value: 'DRAFT')
   */
  status: QuoteStatus;
  submitter_email: Scalars['String'];
  submitter_tz?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['Float']>;
  type: QuoteType;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  valid_until: Scalars['GraphbackDateTime'];
  /** @manyToOne(field: 'fcl_quotes_via', key: 'via_port_id') */
  via_port?: Maybe<Address>;
};


/**
 * @db(name: 'fcl_quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclQuoteQuote_ChargesArgs = {
  filter?: InputMaybe<FclQuoteChargeFilter>;
};

/**
 * @db(name: 'fcl_quote_charges')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FclQuoteCharge = Node & {
  __typename?: 'FclQuoteCharge';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  /**
   * @manyToOne(field: 'quote_charges', key: 'quote_id')
   * @index
   */
  quote: FclQuote;
  /**
   * @manyToOne(field: 'fcl_quote_charges', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  rate: Scalars['Float'];
  /**
   * @manyToOne(field: 'fcl_quote_charges', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  type: ChargeType;
  unit: ChargeUnitType;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type FclQuoteChargeFilter = {
  and?: InputMaybe<Array<FclQuoteChargeFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<FclQuoteChargeFilter>;
  or?: InputMaybe<Array<FclQuoteChargeFilter>>;
  quantity?: InputMaybe<IntInput>;
  quote_id?: InputMaybe<IdInput>;
  quote_request_id?: InputMaybe<IdInput>;
  rate?: InputMaybe<FloatInput>;
  shipper_id?: InputMaybe<IdInput>;
  type?: InputMaybe<StringInput>;
  unit?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type FclQuoteChargePayload = {
  name: Scalars['String'];
  quantity: Scalars['Int'];
  rate: Scalars['Float'];
  type: ChargeType;
  unit: ChargeUnitType;
};

export type FclQuoteFilter = {
  and?: InputMaybe<Array<FclQuoteFilter>>;
  benchmark?: InputMaybe<FloatInput>;
  booking_notes?: InputMaybe<StringInput>;
  capacity_guarantee?: InputMaybe<BooleanInput>;
  carrier?: InputMaybe<StringInput>;
  company_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  destination_port_id?: InputMaybe<IdInput>;
  destination_rail_ramp_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  inland_mode_of_transport?: InputMaybe<StringInput>;
  load_id?: InputMaybe<IdInput>;
  max_transit_time?: InputMaybe<IntInput>;
  min_transit_time?: InputMaybe<IntInput>;
  not?: InputMaybe<FclQuoteFilter>;
  notes?: InputMaybe<StringInput>;
  notes_charges_insurance?: InputMaybe<StringInput>;
  notes_charges_miscellaneous?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<FclQuoteFilter>>;
  origin_port_id?: InputMaybe<IdInput>;
  quote_request_id?: InputMaybe<IdInput>;
  rate_per_container?: InputMaybe<FloatInput>;
  shipper_id?: InputMaybe<IdInput>;
  status?: InputMaybe<StringInput>;
  submitter_email?: InputMaybe<StringInput>;
  submitter_tz?: InputMaybe<StringInput>;
  total_amount?: InputMaybe<FloatInput>;
  type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  valid_until?: InputMaybe<GraphbackDateTimeInput>;
  via_port_id?: InputMaybe<IdInput>;
};

export type FclQuotePortPayload = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  country_name?: InputMaybe<Scalars['String']>;
  google_place_description?: InputMaybe<Scalars['String']>;
  google_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  port_id?: InputMaybe<Scalars['String']>;
  port_name?: InputMaybe<Scalars['String']>;
  province_code?: InputMaybe<Scalars['String']>;
  province_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FclQuoteTotals = {
  __typename?: 'FclQuoteTotals';
  rate_per_container: Scalars['Float'];
  total_amount: Scalars['Float'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  /** flag for Mini RFP / Bid Product */
  bidsRFP?: Maybe<Scalars['Boolean']>;
  /** turn on bulk import */
  bulkImport?: Maybe<Scalars['Boolean']>;
  /** flag for demo features that are sales/customer facing */
  demoOnly?: Maybe<Scalars['Boolean']>;
  /** skip sending out emails after booking */
  doNotSendBookingEmails?: Maybe<Scalars['Boolean']>;
  /** enable async chat feature */
  enableChat?: Maybe<Scalars['Boolean']>;
  /** flag for developers to use internally + is not sales/customer facing */
  internalOnly?: Maybe<Scalars['Boolean']>;
  /** flag for sending out summary emails via crons */
  quotesDailySummaryEmails?: Maybe<Scalars['Boolean']>;
  /** enable shipments feature */
  shipmentsTab?: Maybe<Scalars['Boolean']>;
  /** enable sending emails using sendgrid client */
  useSendGrid?: Maybe<Scalars['Boolean']>;
};

/**
 * @db(name: 'files')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type File = NodeUuid & SoftDeletable & {
  __typename?: 'File';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'files', key: 'created_by_id')
   * @index
   */
  created_by: User;
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'deleted_files', key: 'deleted_by_id') */
  deleted_by?: Maybe<User>;
  extension: Scalars['String'];
  /** @oneToMany(field: 'file', key: 'file_id') */
  files_quotes: Array<FilesQuotes>;
  /**
   * @description This is an uuid & is also used as the key in S3
   * @see https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
   * @id
   */
  id: Scalars['String'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  url: Scalars['String'];
};

export enum FileExtension {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Xls = 'XLS',
  Xlsx = 'XLSX'
}

/**
 * @db(name: 'files')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FileFiles_QuotesArgs = {
  filter?: InputMaybe<FilesQuotesFilter>;
};

export type FileFilter = {
  and?: InputMaybe<Array<FileFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  created_by_id?: InputMaybe<IdInput>;
  deleted_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_by_id?: InputMaybe<IdInput>;
  extension?: InputMaybe<StringInput>;
  id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<FileFilter>;
  or?: InputMaybe<Array<FileFilter>>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @db(name: 'files_quotes')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FilesQuotes = Node & {
  __typename?: 'FilesQuotes';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'files_quotes', key: 'file_id')
   * @index
   */
  file: File;
  id: Scalars['ID'];
  mode: Mode;
  /** @transient */
  quote: QuoteTypes;
  /** @index */
  quote_id: Scalars['String'];
  /**
   * @manyToOne(field: 'files_quotes', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type FilesQuotesFilter = {
  and?: InputMaybe<Array<FilesQuotesFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  file_id?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  mode?: InputMaybe<StringInput>;
  not?: InputMaybe<FilesQuotesFilter>;
  or?: InputMaybe<Array<FilesQuotesFilter>>;
  quote_id?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type FindAddressesForModeInput = {
  excludeAddressTypes?: InputMaybe<Array<AddressType>>;
  mode: Mode;
};

export type FindAddressesForModeResult = {
  __typename?: 'FindAddressesForModeResult';
  items: Array<Address>;
};

export type FindContainersForQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
};

export type FindContainersForQuoteRequestResult = {
  __typename?: 'FindContainersForQuoteRequestResult';
  items: Array<Container>;
};

export type FindFilesForQuoteInput = {
  mode: Mode;
  quoteId: Scalars['ID'];
};

export type FindStopsForQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
};

export type FindStopsForQuoteRequestResult = {
  __typename?: 'FindStopsForQuoteRequestResult';
  items: Array<Stop>;
};

export type FloatInput = {
  between?: InputMaybe<Array<Scalars['Float']>>;
  eq?: InputMaybe<Scalars['Float']>;
  ge?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  le?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
};

export enum FreightClass {
  Fc_50 = 'FC_50',
  Fc_55 = 'FC_55',
  Fc_60 = 'FC_60',
  Fc_65 = 'FC_65',
  Fc_70 = 'FC_70',
  Fc_77_5 = 'FC_77_5',
  Fc_85 = 'FC_85',
  Fc_92_5 = 'FC_92_5',
  Fc_100 = 'FC_100',
  Fc_110 = 'FC_110',
  Fc_125 = 'FC_125',
  Fc_150 = 'FC_150',
  Fc_175 = 'FC_175',
  Fc_200 = 'FC_200',
  Fc_250 = 'FC_250',
  Fc_300 = 'FC_300',
  Fc_400 = 'FC_400',
  Fc_500 = 'FC_500'
}

export type FreightWavesLocationPayload = {
  address_1?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  province_code?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FreightWavesRateBenchmark = {
  __typename?: 'FreightWavesRateBenchmark';
  confidenceScore: Scalars['Int'];
  high: Scalars['Int'];
  low: Scalars['Int'];
  medianAverage: Scalars['Int'];
  status: FreightWavesRateBenchmarkStatus;
};

export enum FreightWavesRateBenchmarkStatus {
  NoResults = 'NO_RESULTS',
  Ok = 'OK',
  UnsupportedEquipmentType = 'UNSUPPORTED_EQUIPMENT_TYPE'
}

/** @description FreightWaves currently only supports van and reefer. */
export enum FreightWavesSupportedEquipmentType {
  Reefer = 'REEFER',
  Van = 'VAN'
}

/**
 * @db(name: 'ftl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FtlLoadSpec = Node & {
  __typename?: 'FtlLoadSpec';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @default(value: 'NONE') */
  driver_preference?: Maybe<DriverPreference>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_palletized?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  packing_count?: Maybe<Scalars['Int']>;
  pallet_count?: Maybe<Scalars['Int']>;
  pallet_type?: Maybe<PalletType>;
  /**
   * @manyToOne(field: 'ftl_load_specs', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  /**
   * @manyToOne(field: 'ftl_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_weight?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  trailer_size?: Maybe<TrailerSize>;
  /** @db(type: 'text') */
  trailer_type?: Maybe<FtlTrailerType>;
  /**
   * @default(value: 1)
   * @description
   * Minimum value is 1.
   * `0` in an invalid value
   */
  truck_quantity?: Maybe<Scalars['Int']>;
  /** @oneToMany(field: 'ftl_load_spec', key: 'ftl_load_spec_id') */
  trucks: Array<Truck>;
  unit_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  weight_per_unit?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'LB')
   */
  weight_unit?: Maybe<WeightUnit>;
};


/**
 * @db(name: 'ftl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FtlLoadSpecTrucksArgs = {
  filter?: InputMaybe<TruckFilter>;
};

export type FtlLoadSpecFilter = {
  and?: InputMaybe<Array<FtlLoadSpecFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  driver_preference?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  is_palletized?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<FtlLoadSpecFilter>;
  or?: InputMaybe<Array<FtlLoadSpecFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  packing_count?: InputMaybe<IntInput>;
  pallet_count?: InputMaybe<IntInput>;
  pallet_type?: InputMaybe<StringInput>;
  quote_request_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_weight?: InputMaybe<FloatInput>;
  trailer_size?: InputMaybe<StringInput>;
  trailer_type?: InputMaybe<StringInput>;
  truck_quantity?: InputMaybe<IntInput>;
  unit_count?: InputMaybe<IntInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_per_unit?: InputMaybe<FloatInput>;
  weight_unit?: InputMaybe<StringInput>;
};

/**
 * @db(name: 'ftl_load_spec_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type FtlLoadSpecTemplate = Node & {
  __typename?: 'FtlLoadSpecTemplate';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @default(value: 'NONE') */
  driver_preference?: Maybe<DriverPreference>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_palletized?: Maybe<Scalars['Boolean']>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  /**
   * @manyToOne(field: 'ftl_load_spec_templates', key: 'quote_request_template_id')
   * @index
   */
  quote_request_template: QuoteRequestTemplate;
  /**
   * @manyToOne(field: 'ftl_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  temp?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'F')
   */
  temp_unit?: Maybe<TempUnit>;
  total_weight?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  trailer_size?: Maybe<TrailerSize>;
  /** @db(type: 'text') */
  trailer_type?: Maybe<FtlTrailerType>;
  /** @oneToOne(field: 'truck_template', key: 'truck_template_id') */
  truck_template?: Maybe<TruckTemplate>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'LB')
   */
  weight_unit?: Maybe<WeightUnit>;
};

export type FtlLoadSpecTemplateFilter = {
  and?: InputMaybe<Array<FtlLoadSpecTemplateFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  driver_preference?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  is_palletized?: InputMaybe<BooleanInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<FtlLoadSpecTemplateFilter>;
  or?: InputMaybe<Array<FtlLoadSpecTemplateFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  quote_request_template_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  temp?: InputMaybe<FloatInput>;
  temp_unit?: InputMaybe<StringInput>;
  total_weight?: InputMaybe<FloatInput>;
  trailer_size?: InputMaybe<StringInput>;
  trailer_type?: InputMaybe<StringInput>;
  truck_template_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

export enum FtlTrailerType {
  BoxTruck = 'BOX_TRUCK',
  Bulk = 'BULK',
  CargoVan = 'CARGO_VAN',
  Conestoga = 'CONESTOGA',
  Drayage = 'DRAYAGE',
  DrayageReefer = 'DRAYAGE_REEFER',
  DryVan = 'DRY_VAN',
  Flatbed = 'FLATBED',
  FoodGradeTank = 'FOOD_GRADE_TANK',
  Hotshot = 'HOTSHOT',
  NaPartnersChoice = 'NA_PARTNERS_CHOICE',
  Other = 'OTHER',
  PartialLoad = 'PARTIAL_LOAD',
  Reefer = 'REEFER',
  Rgn = 'RGN',
  SprinterVan = 'SPRINTER_VAN',
  StepDeck = 'STEP_DECK',
  Dump = 'DUMP'
}

export type GenerateUrlForFileUploadInput = {
  extension: Scalars['String'];
  mode: Mode;
  name: Scalars['String'];
  quoteId: Scalars['ID'];
};

export type GenerateUrlForFileUploadResult = {
  __typename?: 'GenerateUrlForFileUploadResult';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type Get7DayRateBenchmarkInput = {
  quoteRequestId: Scalars['ID'];
};

export type GetAirQuoteTotalsInput = {
  quote_charges: Array<AirQuoteChargePayload>;
};

export type GetBenchmarkFtlInput = {
  destination: FreightWavesLocationPayload;
  equipmentType: FreightWavesSupportedEquipmentType;
  origin: FreightWavesLocationPayload;
};

export type GetFclQuoteTotalsInput = {
  quote_charges: Array<FclQuoteChargePayload>;
};

export type GetPortexAdmins = {
  __typename?: 'GetPortexAdmins';
  items: Array<User>;
};

export type GetShipperPartnerTagsInput = {
  search: Scalars['String'];
};

export type GetShippersResult = {
  __typename?: 'GetShippersResult';
  items: Array<Shipper>;
};

export type GraphbackDateTimeInput = {
  between?: InputMaybe<Array<Scalars['GraphbackDateTime']>>;
  eq?: InputMaybe<Scalars['GraphbackDateTime']>;
  ge?: InputMaybe<Scalars['GraphbackDateTime']>;
  gt?: InputMaybe<Scalars['GraphbackDateTime']>;
  in?: InputMaybe<Array<Scalars['GraphbackDateTime']>>;
  le?: InputMaybe<Scalars['GraphbackDateTime']>;
  lt?: InputMaybe<Scalars['GraphbackDateTime']>;
  ne?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type HideQuoteRequestInput = {
  hide: Scalars['Boolean'];
  /** @example PTX-123456 */
  portex_id: Scalars['String'];
};

export type IdInput = {
  eq?: InputMaybe<Scalars['ID']>;
  ge?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  le?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
};

export type ImpersonateCompanyInput = {
  shipperId?: InputMaybe<Scalars['ID']>;
};

export enum InlandModeOfTransportType {
  OverTheRoad = 'OVER_THE_ROAD',
  Rail = 'RAIL'
}

export type IntInput = {
  between?: InputMaybe<Array<Scalars['Int']>>;
  eq?: InputMaybe<Scalars['Int']>;
  ge?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  le?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
};

export type InviteShipperInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  shipperId: Scalars['ID'];
};

/**
 * @db(name: 'loads')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Load = Node & SoftDeletable & {
  __typename?: 'Load';
  /** @oneToOne(field: 'air_quote', key: 'air_quote_id') */
  air_quote?: Maybe<AirQuote>;
  benchmark?: Maybe<Scalars['Float']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'deleted_loads', key: 'deleted_by_id') */
  deleted_by?: Maybe<User>;
  /** FTL & LTL Only */
  delivery_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @summary normalized string field that's specific for each mode
   * FTL & LTL: `{city}, {province}`
   * FCL: `{city}, {country_code}`
   * AIR: `{airport_iata_code} - {airport_name}`
   */
  destination: Scalars['String'];
  /** FTL & LTL Only */
  equipment_type?: Maybe<EquipmentType>;
  /** @oneToOne(field: 'fcl_quote', key: 'fcl_quote_id') */
  fcl_quote?: Maybe<FclQuote>;
  id: Scalars['ID'];
  /** @oneToOne(field: 'ltl_quote', key: 'ltl_quote_id') */
  ltl_quote?: Maybe<LtlQuote>;
  mode: Mode;
  /**
   * @summary normalized string field that's specific for each mode
   * FTL & LTL: `{city}, {province}`
   * FCL: `{city}, {country_code}`
   * AIR: `{airport_iata_code} - {airport_name}`
   */
  origin: Scalars['String'];
  partner: Scalars['String'];
  /** FTL & LTL Only */
  pickup_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToOne(field: 'quote', key: 'quote_id') */
  quote?: Maybe<Quote>;
  /**
   * @index
   * @oneToOne(field: 'quote_request', key: 'quote_request_id')
   */
  quote_request: QuoteRequest;
  /**
   * @manyToOne(field: 'loads', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  total_amount: Scalars['Float'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type LoadFilter = {
  air_quote_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<LoadFilter>>;
  benchmark?: InputMaybe<FloatInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_at?: InputMaybe<GraphbackDateTimeInput>;
  deleted_by_id?: InputMaybe<IdInput>;
  delivery_at?: InputMaybe<GraphbackDateTimeInput>;
  destination?: InputMaybe<StringInput>;
  equipment_type?: InputMaybe<StringInput>;
  fcl_quote_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  ltl_quote_id?: InputMaybe<IdInput>;
  mode?: InputMaybe<StringInput>;
  not?: InputMaybe<LoadFilter>;
  or?: InputMaybe<Array<LoadFilter>>;
  origin?: InputMaybe<StringInput>;
  partner?: InputMaybe<StringInput>;
  pickup_at?: InputMaybe<GraphbackDateTimeInput>;
  quote_id?: InputMaybe<IdInput>;
  quote_request_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  total_amount?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @db(name: 'ltl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpec = Node & {
  __typename?: 'LtlLoadSpec';
  /** @oneToMany(field: 'ltl_load_spec', key: 'ltl_load_spec_id') */
  accessorials: Array<AccessorialsLtlLoadSpecs>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @oneToMany(field: 'ltl_load_spec', key: 'ltl_load_spec_id') */
  package_groups: Array<PackageGroup>;
  /**
   * @index
   * @oneToOne(field: 'quote_request', key: 'quote_request_id')
   */
  quote_request: QuoteRequest;
  /**
   * @manyToOne(field: 'ltl_load_specs', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @deprecated use 'weight' instead */
  total_weight?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'DRY_VAN')
   */
  trailer_type?: Maybe<LtlTrailerType>;
  /** @oneToOne(field: 'truck', key: 'truck_id') */
  truck?: Maybe<Truck>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  weight?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'LB')
   */
  weight_unit?: Maybe<WeightUnit>;
};


/**
 * @db(name: 'ltl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpecAccessorialsArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecsFilter>;
};


/**
 * @db(name: 'ltl_load_specs')
 * @model(create: false, find: false, findOne: false, update: true, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpecPackage_GroupsArgs = {
  filter?: InputMaybe<PackageGroupFilter>;
};

export type LtlLoadSpecFilter = {
  and?: InputMaybe<Array<LtlLoadSpecFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<LtlLoadSpecFilter>;
  or?: InputMaybe<Array<LtlLoadSpecFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  total_weight?: InputMaybe<FloatInput>;
  trailer_type?: InputMaybe<StringInput>;
  truck_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

/**
 * @db(name: 'ltl_load_spec_templates')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpecTemplate = Node & {
  __typename?: 'LtlLoadSpecTemplate';
  /** @oneToMany(field: 'ltl_load_spec_template', key: 'ltl_load_spec_template_id') */
  accessorials: Array<AccessorialsLtlLoadSpecTemplates>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  /** @oneToMany(field: 'ltl_load_spec_template', key: 'ltl_load_spec_template_id') */
  package_group_templates: Array<PackageGroupTemplate>;
  /**
   * @index
   * @oneToOne(field: 'quote_request_template', key: 'quote_request_template_id')
   */
  quote_request_template: QuoteRequestTemplate;
  /**
   * @manyToOne(field: 'ltl_load_spec_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  total_weight?: Maybe<Scalars['Float']>;
  /**
   * @db(type: 'text')
   * @default(value: 'DRY_VAN')
   */
  trailer_type?: Maybe<LtlTrailerType>;
  /** @oneToOne(field: 'truck_template', key: 'truck_template_id') */
  truck_template?: Maybe<TruckTemplate>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'LB')
   */
  weight_unit?: Maybe<WeightUnit>;
};


/**
 * @db(name: 'ltl_load_spec_templates')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpecTemplateAccessorialsArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecTemplatesFilter>;
};


/**
 * @db(name: 'ltl_load_spec_templates')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlLoadSpecTemplatePackage_Group_TemplatesArgs = {
  filter?: InputMaybe<PackageGroupTemplateFilter>;
};

export type LtlLoadSpecTemplateFilter = {
  and?: InputMaybe<Array<LtlLoadSpecTemplateFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  max_temp?: InputMaybe<FloatInput>;
  min_temp?: InputMaybe<FloatInput>;
  not?: InputMaybe<LtlLoadSpecTemplateFilter>;
  or?: InputMaybe<Array<LtlLoadSpecTemplateFilter>>;
  quote_request_template_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  total_weight?: InputMaybe<FloatInput>;
  trailer_type?: InputMaybe<StringInput>;
  truck_template_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_unit?: InputMaybe<StringInput>;
};

export type LtlPublicPackageGroup = {
  __typename?: 'LtlPublicPackageGroup';
  commodities?: Maybe<Scalars['String']>;
  freight_class?: Maybe<FreightClass>;
  hazardous_goods_details?: Maybe<Scalars['String']>;
  is_hazardous?: Maybe<Scalars['Boolean']>;
  is_stackable?: Maybe<Scalars['Boolean']>;
  item_quantity: Scalars['Int'];
  nmfc_code?: Maybe<Scalars['String']>;
  packaging_type: PackagingType;
  per_package_dimensions_height?: Maybe<Scalars['Float']>;
  per_package_dimensions_length?: Maybe<Scalars['Float']>;
  per_package_dimensions_unit: DimUnit;
  per_package_dimensions_width?: Maybe<Scalars['Float']>;
  per_package_weight: Scalars['Float'];
  per_package_weight_unit: WeightUnit;
};

/**
 * @db(name: 'ltl_quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type LtlQuote = Node & {
  __typename?: 'LtlQuote';
  /** @db(type: 'text') */
  booking_notes?: Maybe<Scalars['String']>;
  /**
   * @db(type: 'text')
   * @default(value: '')
   */
  carrier_name: Scalars['String'];
  company_name?: Maybe<Scalars['String']>;
  /** @transient */
  conversation_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @oneToOne(field: 'load', key: 'load_id') */
  load?: Maybe<Load>;
  max_transit_time?: Maybe<Scalars['Int']>;
  min_transit_time?: Maybe<Scalars['Int']>;
  /** @db(type: 'text') */
  notes?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'ltl_quotes', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  /**
   * @manyToOne(field: 'ltl_quotes', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /**
   * @db(type: 'text')
   * @default(value: 'SUBMITTED')
   */
  status: QuoteStatus;
  submitter_email: Scalars['String'];
  submitter_tz?: Maybe<Scalars['String']>;
  total_amount: Scalars['Float'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  valid_until: Scalars['GraphbackDateTime'];
};

export type LtlQuoteFilter = {
  and?: InputMaybe<Array<LtlQuoteFilter>>;
  booking_notes?: InputMaybe<StringInput>;
  carrier_name?: InputMaybe<StringInput>;
  company_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  load_id?: InputMaybe<IdInput>;
  max_transit_time?: InputMaybe<IntInput>;
  min_transit_time?: InputMaybe<IntInput>;
  not?: InputMaybe<LtlQuoteFilter>;
  notes?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<LtlQuoteFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  status?: InputMaybe<StringInput>;
  submitter_email?: InputMaybe<StringInput>;
  submitter_tz?: InputMaybe<StringInput>;
  total_amount?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  valid_until?: InputMaybe<GraphbackDateTimeInput>;
};

export enum LtlTrailerType {
  DryVan = 'DRY_VAN',
  Flatbed = 'FLATBED',
  Hotshot = 'HOTSHOT',
  NaPartnersChoice = 'NA_PARTNERS_CHOICE',
  Reefer = 'REEFER',
  StepDeck = 'STEP_DECK'
}

export enum Mode {
  Air = 'AIR',
  Drayage = 'DRAYAGE',
  Fcl = 'FCL',
  Ftl = 'FTL',
  Lcl = 'LCL',
  Ltl = 'LTL'
}

export enum ModeVolume {
  ModeVolume_0 = 'MODE_VOLUME_0',
  ModeVolume_1 = 'MODE_VOLUME_1',
  ModeVolume_2 = 'MODE_VOLUME_2',
  ModeVolume_3 = 'MODE_VOLUME_3',
  ModeVolume_4 = 'MODE_VOLUME_4'
}

export type MutateAirLoadSpecInput = {
  cargo_ready_date?: InputMaybe<Scalars['GraphbackDateTime']>;
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  height_per_package?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  include_customs_clearance?: InputMaybe<Scalars['Boolean']>;
  incoterms?: InputMaybe<AirIncoterms>;
  is_overweight?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  length_per_package?: InputMaybe<Scalars['Float']>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  routing_type?: InputMaybe<RoutingType>;
  service_levels?: InputMaybe<Array<InputMaybe<ServiceLevel>>>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  target_delivery_date?: InputMaybe<Scalars['GraphbackDateTime']>;
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  total_volume?: InputMaybe<Scalars['Float']>;
  total_weight?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  volume_format?: InputMaybe<VolumeFormat>;
  weight_unit?: InputMaybe<WeightUnit>;
  width_per_package?: InputMaybe<Scalars['Float']>;
};

export type MutateAirPackageGroupInput = {
  air_load_spec_id?: InputMaybe<Scalars['ID']>;
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  hazardous_goods_details?: InputMaybe<Scalars['String']>;
  height_per_package?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  length_per_package?: InputMaybe<Scalars['Float']>;
  packaging_type?: InputMaybe<PackagingType>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  volume_format?: InputMaybe<VolumeFormat>;
  volume_per_item?: InputMaybe<Scalars['Float']>;
  weight_per_package?: InputMaybe<Scalars['Float']>;
  width_per_package?: InputMaybe<Scalars['Float']>;
};

export type MutateContactsQuoteRequestsInput = {
  contact_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  quote_request_id?: InputMaybe<Scalars['ID']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type MutateContainerInput = {
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  fcl_load_spec_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  requires_genset?: InputMaybe<Scalars['Boolean']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  size?: InputMaybe<ContainerSize>;
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  type?: InputMaybe<ContainerType>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  volume?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type MutateDrayageLoadSpecInput = {
  commodities?: InputMaybe<Scalars['String']>;
  container_number?: InputMaybe<Scalars['String']>;
  container_size?: InputMaybe<ContainerSize>;
  container_type?: InputMaybe<ContainerType>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  ocean_bol_number?: InputMaybe<Scalars['String']>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  requires_genset?: InputMaybe<Scalars['Boolean']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  total_weight?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_unit?: InputMaybe<WeightUnit>;
};

export type MutateFclLoadSpecInput = {
  capacity_guarantee_required?: InputMaybe<Scalars['Boolean']>;
  cargo_ready_date?: InputMaybe<Scalars['GraphbackDateTime']>;
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  direct_sailing_required?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  include_customs_clearance?: InputMaybe<Scalars['Boolean']>;
  incoterms?: InputMaybe<OceanIncoterms>;
  is_overweight?: InputMaybe<Scalars['Boolean']>;
  is_palletized?: InputMaybe<Scalars['Boolean']>;
  packaging_type?: InputMaybe<PackagingType>;
  packing_count?: InputMaybe<Scalars['Int']>;
  pallet_count?: InputMaybe<Scalars['Int']>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  quote_type?: InputMaybe<QuoteType>;
  quote_types?: InputMaybe<Array<InputMaybe<QuoteType>>>;
  routing_type?: InputMaybe<RoutingType>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  target_delivery_date?: InputMaybe<Scalars['GraphbackDateTime']>;
  total_weight?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_unit?: InputMaybe<WeightUnit>;
};

export type MutateFtlLoadSpecInput = {
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  driver_preference?: InputMaybe<DriverPreference>;
  id: Scalars['ID'];
  is_palletized?: InputMaybe<Scalars['Boolean']>;
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  packaging_type?: InputMaybe<PackagingType>;
  packing_count?: InputMaybe<Scalars['Int']>;
  pallet_count?: InputMaybe<Scalars['Int']>;
  pallet_type?: InputMaybe<PalletType>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  temp?: InputMaybe<Scalars['Float']>;
  temp_unit?: InputMaybe<TempUnit>;
  total_weight?: InputMaybe<Scalars['Float']>;
  trailer_size?: InputMaybe<TrailerSize>;
  trailer_type?: InputMaybe<FtlTrailerType>;
  truck_quantity?: InputMaybe<Scalars['Int']>;
  unit_count?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_per_unit?: InputMaybe<Scalars['Float']>;
  weight_unit?: InputMaybe<WeightUnit>;
};

export type MutateLtlLoadSpecInput = {
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  max_temp?: InputMaybe<Scalars['Float']>;
  min_temp?: InputMaybe<Scalars['Float']>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  total_weight?: InputMaybe<Scalars['Float']>;
  trailer_type?: InputMaybe<LtlTrailerType>;
  truck_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_unit?: InputMaybe<WeightUnit>;
};

export type MutatePackageGroupInput = {
  commodities?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  dim_unit?: InputMaybe<DimUnit>;
  freight_class?: InputMaybe<FreightClass>;
  hazardous_goods_details?: InputMaybe<Scalars['String']>;
  height_per_package?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  is_stackable?: InputMaybe<Scalars['Boolean']>;
  item_quantity?: InputMaybe<Scalars['Int']>;
  length_per_package?: InputMaybe<Scalars['Float']>;
  ltl_load_spec_id?: InputMaybe<Scalars['ID']>;
  nmfc_code?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<PackagingType>;
  packing_count?: InputMaybe<Scalars['Int']>;
  pallet_count?: InputMaybe<Scalars['Int']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  weight_per_package?: InputMaybe<Scalars['Float']>;
  width_per_package?: InputMaybe<Scalars['Float']>;
};

export type MutateStopInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  distance_from_prior_stop?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  is_na?: InputMaybe<Scalars['Boolean']>;
  is_time_tbd?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  quote_request_id?: InputMaybe<Scalars['ID']>;
  reference_number?: InputMaybe<Scalars['String']>;
  shipper_id?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['GraphbackDateTime']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type MutateUserDefaultInput = {
  created_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  per_truck_notes?: InputMaybe<Scalars['Boolean']>;
  plain_text_email?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bookQuote: Scalars['Boolean'];
  cancelQuoteRequest: Scalars['Boolean'];
  closeQuoteRequest?: Maybe<Scalars['Boolean']>;
  completeSignupInvitation: User;
  createAddress?: Maybe<Address>;
  createAirPackageGroup?: Maybe<AirPackageGroup>;
  createContact?: Maybe<Contact>;
  createContactsQuoteRequests?: Maybe<ContactsQuoteRequests>;
  createContainer?: Maybe<Container>;
  createDrayageLoadSpec?: Maybe<DrayageLoadSpec>;
  createEmptyQuoteRequest?: Maybe<QuoteRequest>;
  createPackageGroup?: Maybe<PackageGroup>;
  createPartnerTag: Tag;
  createPreviewPublicQuoteRequestLink?: Maybe<Scalars['String']>;
  createQuoteRequestFromExistingQuoteRequest?: Maybe<QuoteRequest>;
  createQuoteRequestFromTemplate?: Maybe<QuoteRequest>;
  createQuoteRequestTemplateFromQuoteRequest?: Maybe<QuoteRequestTemplate>;
  createQuoteSubmissionLink?: Maybe<Scalars['String']>;
  /** (Portex Admin Only) */
  createShipper: Shipper;
  createStop?: Maybe<Stop>;
  deleteAddress?: Maybe<Scalars['Boolean']>;
  deleteAirPackageGroup?: Maybe<AirPackageGroup>;
  deleteContact?: Maybe<Scalars['Boolean']>;
  deleteContactsQuoteRequests?: Maybe<ContactsQuoteRequests>;
  deleteContainer?: Maybe<Container>;
  deleteDrayageLoadSpec?: Maybe<DrayageLoadSpec>;
  deleteFile: Scalars['Boolean'];
  deletePackageGroup?: Maybe<PackageGroup>;
  deleteStop?: Maybe<Stop>;
  generateUrlForFileUpload: GenerateUrlForFileUploadResult;
  /** (Portex Admin Only) */
  hideQuoteRequest: Scalars['Boolean'];
  /** (Portex Admin Only) */
  impersonateCompany: User;
  /** (Portex Admin Only) */
  inviteShipper: Scalars['Boolean'];
  onboardShipper?: Maybe<SignupSurveyShipper>;
  replaceAccessorials?: Maybe<LtlLoadSpec>;
  sendNewQuoteRequestEmail?: Maybe<Scalars['Boolean']>;
  /** (Portex Admin Only) */
  sendTestEmail: Scalars['Boolean'];
  /**
   * (Portex Super Admin Only)
   * development only
   */
  sendTransactionalEmail: SendTransactionalEmailResult;
  /** (Portex Admin Only) */
  stopImpersonation: User;
  submitAirQuote: Scalars['Boolean'];
  submitFclQuote: Scalars['Boolean'];
  submitLtlQuote: Scalars['Boolean'];
  submitQuote: Scalars['Boolean'];
  submitQuoteRequest?: Maybe<QuoteRequest>;
  /** (Portex Admin Only) */
  switchShipper: Scalars['Boolean'];
  updateAddressLabel?: Maybe<Address>;
  updateAirLoadSpec?: Maybe<AirLoadSpec>;
  updateAirPackageGroup?: Maybe<AirPackageGroup>;
  updateCargoDetails: QuoteRequest;
  updateContainer?: Maybe<Container>;
  updateContainersForQuoteRequest: QuoteRequest;
  updateDrayageLoadSpec?: Maybe<DrayageLoadSpec>;
  updateFclLoadSpec?: Maybe<FclLoadSpec>;
  updateFtlLoadSpec?: Maybe<FtlLoadSpec>;
  updateLtlLoadSpec?: Maybe<LtlLoadSpec>;
  updatePackageGroup?: Maybe<PackageGroup>;
  updatePartner?: Maybe<Contact>;
  updateQuoteRequest?: Maybe<QuoteRequest>;
  updateQuoteRequestPartners?: Maybe<QuoteRequest>;
  updateQuoteRequestQuoteTypes: QuoteRequest;
  updateQuoteRequestRouting?: Maybe<QuoteRequest>;
  updateQuoteRequestRoutingDetails: QuoteRequest;
  updateQuoteRequestTeam?: Maybe<QuoteRequest>;
  updateQuoteRequestWeightUnit?: Maybe<QuoteRequest>;
  updateSelf?: Maybe<User>;
  updateStop?: Maybe<Stop>;
  updateStopDetails: Stop;
  updateStopsForQuoteRequest: QuoteRequest;
  updateTeamMember?: Maybe<Contact>;
  updateTruck?: Maybe<Truck>;
  updateUserDefault?: Maybe<UserDefault>;
};


export type MutationBookQuoteArgs = {
  input: BookQuoteInput;
};


export type MutationCancelQuoteRequestArgs = {
  input: CancelQuoteRequestInput;
};


export type MutationCloseQuoteRequestArgs = {
  input: CloseQuoteRequestInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAirPackageGroupArgs = {
  input: CreateAirPackageGroupInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContactsQuoteRequestsArgs = {
  input: CreateContactsQuoteRequestsInput;
};


export type MutationCreateContainerArgs = {
  input: CreateContainerInput;
};


export type MutationCreateDrayageLoadSpecArgs = {
  input: CreateDrayageLoadSpecInput;
};


export type MutationCreateEmptyQuoteRequestArgs = {
  mode: Mode;
};


export type MutationCreatePackageGroupArgs = {
  input: CreatePackageGroupInput;
};


export type MutationCreatePartnerTagArgs = {
  input: CreatePartnerTagInput;
};


export type MutationCreatePreviewPublicQuoteRequestLinkArgs = {
  input: CreatePreviewPublicQuoteRequestLinkInput;
};


export type MutationCreateQuoteRequestFromExistingQuoteRequestArgs = {
  input: CreateQuoteRequestFromExistingQuoteRequestInput;
};


export type MutationCreateQuoteRequestFromTemplateArgs = {
  input: Scalars['ID'];
};


export type MutationCreateQuoteRequestTemplateFromQuoteRequestArgs = {
  input: CreateQuoteRequestTemplateFromQuoteRequestInput;
};


export type MutationCreateQuoteSubmissionLinkArgs = {
  input: CreateQuoteSubmissionLinkInput;
};


export type MutationCreateShipperArgs = {
  input: CreateShipperInput;
};


export type MutationCreateStopArgs = {
  input: CreateStopInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddress;
};


export type MutationDeleteAirPackageGroupArgs = {
  input: MutateAirPackageGroupInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteContactsQuoteRequestsArgs = {
  input: MutateContactsQuoteRequestsInput;
};


export type MutationDeleteContainerArgs = {
  input: MutateContainerInput;
};


export type MutationDeleteDrayageLoadSpecArgs = {
  input: MutateDrayageLoadSpecInput;
};


export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


export type MutationDeletePackageGroupArgs = {
  input: MutatePackageGroupInput;
};


export type MutationDeleteStopArgs = {
  input: MutateStopInput;
};


export type MutationGenerateUrlForFileUploadArgs = {
  input: GenerateUrlForFileUploadInput;
};


export type MutationHideQuoteRequestArgs = {
  input: HideQuoteRequestInput;
};


export type MutationImpersonateCompanyArgs = {
  input: ImpersonateCompanyInput;
};


export type MutationInviteShipperArgs = {
  input: InviteShipperInput;
};


export type MutationOnboardShipperArgs = {
  input: OnboardShipperInput;
};


export type MutationReplaceAccessorialsArgs = {
  input: ReplaceAccessorialsInput;
};


export type MutationSendNewQuoteRequestEmailArgs = {
  input: SendNewQuoteRequestEmailInput;
};


export type MutationSendTestEmailArgs = {
  input: SendTestEmailInput;
};


export type MutationSendTransactionalEmailArgs = {
  input: SendTransactionalEmailInput;
};


export type MutationStopImpersonationArgs = {
  input?: InputMaybe<StopImpersonationInput>;
};


export type MutationSubmitAirQuoteArgs = {
  input: SubmitAirQuoteInput;
};


export type MutationSubmitFclQuoteArgs = {
  input: SubmitFclQuoteInput;
};


export type MutationSubmitLtlQuoteArgs = {
  input: SubmitLtlQuoteInput;
};


export type MutationSubmitQuoteArgs = {
  input: SubmitQuoteInput;
};


export type MutationSubmitQuoteRequestArgs = {
  input: SubmitQuoteRequestInput;
};


export type MutationSwitchShipperArgs = {
  input: SwitchShipperInput;
};


export type MutationUpdateAddressLabelArgs = {
  input: UpdateAddressLabelInput;
};


export type MutationUpdateAirLoadSpecArgs = {
  input: MutateAirLoadSpecInput;
};


export type MutationUpdateAirPackageGroupArgs = {
  input: MutateAirPackageGroupInput;
};


export type MutationUpdateCargoDetailsArgs = {
  input: UpdateCargoDetailsInput;
};


export type MutationUpdateContainerArgs = {
  input: MutateContainerInput;
};


export type MutationUpdateContainersForQuoteRequestArgs = {
  input: UpdateContainersForQuoteRequestInput;
};


export type MutationUpdateDrayageLoadSpecArgs = {
  input: MutateDrayageLoadSpecInput;
};


export type MutationUpdateFclLoadSpecArgs = {
  input: MutateFclLoadSpecInput;
};


export type MutationUpdateFtlLoadSpecArgs = {
  input: MutateFtlLoadSpecInput;
};


export type MutationUpdateLtlLoadSpecArgs = {
  input: MutateLtlLoadSpecInput;
};


export type MutationUpdatePackageGroupArgs = {
  input: MutatePackageGroupInput;
};


export type MutationUpdatePartnerArgs = {
  input: UpdatePartnerInput;
};


export type MutationUpdateQuoteRequestArgs = {
  input: UpdateQuoteRequestInput;
};


export type MutationUpdateQuoteRequestPartnersArgs = {
  input: UpdateQuoteRequestRecipientsInput;
};


export type MutationUpdateQuoteRequestQuoteTypesArgs = {
  input: UpdateQuoteRequestQuoteTypesInput;
};


export type MutationUpdateQuoteRequestRoutingArgs = {
  input: UpdateQuoteRequestRoutingInput;
};


export type MutationUpdateQuoteRequestRoutingDetailsArgs = {
  input: UpdateQuoteRequestRoutingDetailsInput;
};


export type MutationUpdateQuoteRequestTeamArgs = {
  input: UpdateQuoteRequestRecipientsInput;
};


export type MutationUpdateQuoteRequestWeightUnitArgs = {
  input: UpdateQuoteRequestWeightUnitInput;
};


export type MutationUpdateSelfArgs = {
  input: UpdateSelfInput;
};


export type MutationUpdateStopArgs = {
  input: MutateStopInput;
};


export type MutationUpdateStopDetailsArgs = {
  input: UpdateStopDetailsInput;
};


export type MutationUpdateStopsForQuoteRequestArgs = {
  input: UpdateStopsForQuoteRequestInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateTruckArgs = {
  input: UpdateTruckInput;
};


export type MutationUpdateUserDefaultArgs = {
  input: MutateUserDefaultInput;
};

export type Node = {
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type NodeUuid = {
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['String'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

/** Incoterms specific to Ocean modes (FCL / LCL) */
export enum OceanIncoterms {
  Cfr = 'CFR',
  Cif = 'CIF',
  Cip = 'CIP',
  Cpt = 'CPT',
  Dap = 'DAP',
  Ddp = 'DDP',
  Dpu = 'DPU',
  Exw = 'EXW',
  Fas = 'FAS',
  Fca = 'FCA',
  Fob = 'FOB'
}

export type OnboardShipperInput = {
  company_name: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  job_title?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mode_air: Scalars['Boolean'];
  mode_fcl: Scalars['Boolean'];
  mode_ftl: Scalars['Boolean'];
  partner_count: PartnerCount;
  phone?: InputMaybe<Scalars['String']>;
  volume_air: ModeVolume;
  volume_fcl: ModeVolume;
  volume_ftl: ModeVolume;
};

export type OrderByFilterInput = {
  field: Scalars['String'];
  order?: InputMaybe<SortDirectionFilterEnum>;
};

export type OrderByInput = {
  field: Scalars['String'];
  order?: InputMaybe<SortDirectionEnum>;
};

export enum OutlookMode {
  MessageCompose = 'MESSAGE_COMPOSE',
  MessageRead = 'MESSAGE_READ'
}

/**
 * @db(name: 'package_groups')
 * @model(create: true, find: false, findOne: false, update: true, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type PackageGroup = Node & {
  __typename?: 'PackageGroup';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'IN')
   */
  dim_unit: DimUnit;
  /** @db(type: 'text') */
  freight_class?: Maybe<FreightClass>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_stackable?: Maybe<Scalars['Boolean']>;
  /** @default(value: 1) */
  item_quantity: Scalars['Int'];
  length_per_package?: Maybe<Scalars['Float']>;
  /**
   * @manyToOne(field: 'package_groups', key: 'ltl_load_spec_id')
   * @index
   */
  ltl_load_spec: LtlLoadSpec;
  nmfc_code?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  packing_count?: Maybe<Scalars['Int']>;
  pallet_count?: Maybe<Scalars['Int']>;
  /**
   * @manyToOne(field: 'package_groups', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  weight_per_package?: Maybe<Scalars['Float']>;
  width_per_package?: Maybe<Scalars['Float']>;
};

export type PackageGroupFilter = {
  and?: InputMaybe<Array<PackageGroupFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  dim_unit?: InputMaybe<StringInput>;
  freight_class?: InputMaybe<StringInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  is_stackable?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  ltl_load_spec_id?: InputMaybe<IdInput>;
  nmfc_code?: InputMaybe<StringInput>;
  not?: InputMaybe<PackageGroupFilter>;
  or?: InputMaybe<Array<PackageGroupFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  packing_count?: InputMaybe<IntInput>;
  pallet_count?: InputMaybe<IntInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_per_package?: InputMaybe<FloatInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

/**
 * @db(name: 'package_group_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type PackageGroupTemplate = Node & {
  __typename?: 'PackageGroupTemplate';
  /** @db(type: 'text') */
  commodities?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @db(type: 'text')
   * @default(value: 'IN')
   */
  dim_unit: DimUnit;
  /** @db(type: 'text') */
  freight_class?: Maybe<FreightClass>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  height_per_package?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_hazardous?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_stackable?: Maybe<Scalars['Boolean']>;
  /** @default(value: 1) */
  item_quantity: Scalars['Int'];
  length_per_package?: Maybe<Scalars['Float']>;
  /**
   * @manyToOne(field: 'package_group_templates', key: 'ltl_load_spec_template_id')
   * @index
   */
  ltl_load_spec_template: LtlLoadSpecTemplate;
  nmfc_code?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  packaging_type?: Maybe<PackagingType>;
  /**
   * @manyToOne(field: 'package_group_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  weight_per_package?: Maybe<Scalars['Float']>;
  width_per_package?: Maybe<Scalars['Float']>;
};

export type PackageGroupTemplateFilter = {
  and?: InputMaybe<Array<PackageGroupTemplateFilter>>;
  commodities?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  dim_unit?: InputMaybe<StringInput>;
  freight_class?: InputMaybe<StringInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  height_per_package?: InputMaybe<FloatInput>;
  id?: InputMaybe<IdInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  is_stackable?: InputMaybe<BooleanInput>;
  item_quantity?: InputMaybe<IntInput>;
  length_per_package?: InputMaybe<FloatInput>;
  ltl_load_spec_template_id?: InputMaybe<IdInput>;
  nmfc_code?: InputMaybe<StringInput>;
  not?: InputMaybe<PackageGroupTemplateFilter>;
  or?: InputMaybe<Array<PackageGroupTemplateFilter>>;
  packaging_type?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  weight_per_package?: InputMaybe<FloatInput>;
  width_per_package?: InputMaybe<FloatInput>;
};

export enum PackagingType {
  Bags = 'BAGS',
  Bales = 'BALES',
  Barrels = 'BARRELS',
  Boxes = 'BOXES',
  Bundles = 'BUNDLES',
  Cartons = 'CARTONS',
  Coils = 'COILS',
  Containers = 'CONTAINERS',
  Crates = 'CRATES',
  Other = 'OTHER',
  Pallets = 'PALLETS',
  Pallets_48_40 = 'PALLETS_48_40',
  Pallets_48_48 = 'PALLETS_48_48',
  Rolls = 'ROLLS',
  Skids = 'SKIDS',
  Totes = 'TOTES',
  Cases = 'CASES'
}

export type PageInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PageRequest = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum PalletType {
  Pallet_36_36 = 'PALLET_36_36',
  Pallet_40_40 = 'PALLET_40_40',
  Pallet_40_48 = 'PALLET_40_48',
  Pallet_42_42 = 'PALLET_42_42',
  Pallet_44_44 = 'PALLET_44_44',
  Pallet_45_455 = 'PALLET_45_455',
  Pallet_48_20 = 'PALLET_48_20',
  Pallet_48_36 = 'PALLET_48_36',
  Pallet_48_40 = 'PALLET_48_40',
  Pallet_48_42 = 'PALLET_48_42',
  Pallet_48_45 = 'PALLET_48_45',
  Pallet_48_48 = 'PALLET_48_48',
  PalletNotSpecified = 'PALLET_NOT_SPECIFIED'
}

export enum PartnerCount {
  PartnerCount_0 = 'PARTNER_COUNT_0',
  PartnerCount_1 = 'PARTNER_COUNT_1',
  PartnerCount_2 = 'PARTNER_COUNT_2',
  PartnerCount_3 = 'PARTNER_COUNT_3'
}

export type PartnerFilter = {
  city?: InputMaybe<StringFilterInput>;
  company_name?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  first_name?: InputMaybe<StringFilterInput>;
  last_name?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<PartnerFilter>>;
  phone_number?: InputMaybe<StringFilterInput>;
  state?: InputMaybe<StringFilterInput>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

export type PartnerResultList = ResultList & {
  __typename?: 'PartnerResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Contact>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

/**
 * @db(name: 'ports')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Port = Node & {
  __typename?: 'Port';
  city: Scalars['String'];
  country_code: Scalars['String'];
  country_name: Scalars['String'];
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  iana_timezone: Scalars['String'];
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['String']>;
  lowercase_name: Scalars['String'];
  name: Scalars['String'];
  province_code?: Maybe<Scalars['String']>;
  province_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type PortFilter = {
  and?: InputMaybe<Array<PortFilter>>;
  city?: InputMaybe<StringInput>;
  country_code?: InputMaybe<StringInput>;
  country_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  lat?: InputMaybe<StringInput>;
  lon?: InputMaybe<StringInput>;
  lowercase_name?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<PortFilter>;
  or?: InputMaybe<Array<PortFilter>>;
  province_code?: InputMaybe<StringInput>;
  province_name?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type PortResultList = {
  __typename?: 'PortResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<Port>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PreviewPublicQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
};

export type PublicChargeAir = {
  __typename?: 'PublicChargeAir';
  item_quantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** item quantity * weight */
  quantity: Scalars['Float'];
  type: ChargeType;
  unit: ChargeUnitType;
};

export type PublicChargeFcl = {
  __typename?: 'PublicChargeFcl';
  name: Scalars['String'];
  quantity: Scalars['Int'];
  type: ChargeType;
  unit: ChargeUnitType;
};

export type PublicContainer = {
  __typename?: 'PublicContainer';
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  requires_genset: Scalars['Boolean'];
  size: ContainerSize;
  type: ContainerType;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type PublicLocation = {
  __typename?: 'PublicLocation';
  airport_iata_code: Scalars['String'];
  airport_name: Scalars['String'];
  city: Scalars['String'];
  country_code: Scalars['String'];
  country_name: Scalars['String'];
  end?: Maybe<Scalars['GraphbackDateTime']>;
  formatted_long_name: Scalars['String'];
  formatted_short_name: Scalars['String'];
  iana_timezone: Scalars['String'];
  address_id: Scalars['String'];
  is_time_tbd: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  port_name: Scalars['String'];
  position: Scalars['Int'];
  start?: Maybe<Scalars['GraphbackDateTime']>;
  type: AddressType;
  zip: Scalars['String'];
};

export type PublicPackageGroup = {
  __typename?: 'PublicPackageGroup';
  commodities?: Maybe<Scalars['String']>;
  hazardous_goods_details?: Maybe<Scalars['String']>;
  is_hazardous?: Maybe<Scalars['Boolean']>;
  item_quantity: Scalars['Int'];
  packaging_type: PackagingType;
  per_package_dimensions_height?: Maybe<Scalars['Float']>;
  per_package_dimensions_length?: Maybe<Scalars['Float']>;
  per_package_dimensions_unit: DimUnit;
  per_package_dimensions_width?: Maybe<Scalars['Float']>;
  per_package_volume?: Maybe<Scalars['Float']>;
  per_package_volume_unit: VolumeFormat;
  per_package_weight: Scalars['Float'];
  per_package_weight_unit: WeightUnit;
};

export type PublicQuoteRequest = {
  __typename?: 'PublicQuoteRequest';
  accessorials: Array<Accessorial>;
  capacity_guarantee_required: Scalars['Boolean'];
  cargo_ready_date?: Maybe<Scalars['GraphbackDateTime']>;
  cargo_ready_date_tz: Scalars['String'];
  carrier_routing_pref_notes?: Maybe<Scalars['String']>;
  charges: Array<PublicChargeFcl>;
  charges_air: Array<PublicChargeAir>;
  commodities?: Maybe<Scalars['String']>;
  containers: Array<PublicContainer>;
  deadline_respond_at?: Maybe<Scalars['GraphbackDateTime']>;
  direct_sailing_required: Scalars['Boolean'];
  /** @default(value: 'NONE') */
  driver_preference?: Maybe<DriverPreference>;
  goods_value?: Maybe<Scalars['Float']>;
  guid: Scalars['String'];
  hazardous_goods_details: Scalars['String'];
  include_customs_clearance: Scalars['Boolean'];
  incoterms_air?: Maybe<AirIncoterms>;
  incoterms_ocean?: Maybe<OceanIncoterms>;
  insurance_required: Scalars['Boolean'];
  is_hazardous: Scalars['Boolean'];
  is_overweight: Scalars['Boolean'];
  item_packaging: Scalars['String'];
  item_quantity?: Maybe<Scalars['Int']>;
  item_type?: Maybe<PackagingType>;
  locations: Array<Maybe<PublicLocation>>;
  ltl_trailer_type?: Maybe<LtlTrailerType>;
  max_temp?: Maybe<Scalars['Float']>;
  min_temp?: Maybe<Scalars['Float']>;
  mode: Mode;
  notes?: Maybe<Scalars['String']>;
  package_groups: Array<PublicPackageGroup>;
  package_groups_ltl: Array<LtlPublicPackageGroup>;
  packing_count?: Maybe<Scalars['Int']>;
  pallet_count?: Maybe<Scalars['Int']>;
  pallet_type: PalletType;
  /** @deprecated use dimensions from individual items in 'package_groups' */
  per_package_dimensions_height?: Maybe<Scalars['Float']>;
  /** @deprecated use dimensions from individual items in 'package_groups' */
  per_package_dimensions_length?: Maybe<Scalars['Float']>;
  /** @deprecated use dimensions from individual items in 'package_groups' */
  per_package_dimensions_width?: Maybe<Scalars['Float']>;
  portex_id: Scalars['String'];
  quote_type?: Maybe<QuoteType>;
  quote_types: Array<QuoteType>;
  reference_number: Scalars['String'];
  routing_type?: Maybe<RoutingType>;
  service_levels: Array<ServiceLevel>;
  shipper_name: Scalars['String'];
  state: QuoteRequestState;
  subject_line: Scalars['String'];
  target_delivery_date?: Maybe<Scalars['GraphbackDateTime']>;
  target_delivery_date_tz: Scalars['String'];
  temp?: Maybe<Scalars['Float']>;
  temp_unit?: Maybe<TempUnit>;
  total_volume?: Maybe<Scalars['Float']>;
  total_weight?: Maybe<Scalars['Float']>;
  trailer_size?: Maybe<TrailerSize>;
  trailer_type?: Maybe<FtlTrailerType>;
  truck_quantity?: Maybe<Scalars['Int']>;
  type?: Maybe<RequestType>;
  /**  @summary derived from `QuoteRequest.unloaded_details`  */
  unloading_details?: Maybe<UnloadingDetails>;
  volume_format?: Maybe<VolumeFormat>;
  weight_unit?: Maybe<WeightUnit>;
};

export type Query = {
  __typename?: 'Query';
  findAccessorials: AccessorialResultList;
  findAddresses: AddressResultList;
  findAddressesForMode: FindAddressesForModeResult;
  findAirports: AirportResultList;
  findContacts: ContactResultList;
  findContactsQuoteRequests: ContactsQuoteRequestsResultList;
  findContainersForQuoteRequest: FindContainersForQuoteRequestResult;
  findFilesForQuote: Array<File>;
  findPartners: PartnerResultList;
  findPorts: PortResultList;
  findQuoteRequestTemplates: QuoteRequestTemplateResultList;
  findQuoteRequests: QuoteRequestResultList;
  findStopsForQuoteRequest: FindStopsForQuoteRequestResult;
  get7DayRateBenchmark: FreightWavesRateBenchmark;
  getAirQuote?: Maybe<AirQuote>;
  getAirQuoteTotals: AirQuoteTotals;
  getAirport?: Maybe<Airport>;
  getBenchmarkFTL: FreightWavesRateBenchmark;
  getContact?: Maybe<Contact>;
  getCurrentFeatureFlags: FeatureFlags;
  getCurrentUser: User;
  getCurrentUserDefault: UserDefault;
  getFclQuote?: Maybe<FclQuote>;
  getFclQuoteTotals: FclQuoteTotals;
  getLtlLoadSpecTemplate?: Maybe<LtlLoadSpecTemplate>;
  getLtlQuote?: Maybe<LtlQuote>;
  getPortexAdmins: GetPortexAdmins;
  getPublicQuoteRequest?: Maybe<PublicQuoteRequest>;
  getQuote?: Maybe<Quote>;
  getQuoteRequest?: Maybe<QuoteRequest>;
  getShipperPartnerTags: Array<Tag>;
  /** (Portex Admin Only) */
  getShippers: GetShippersResult;
  getTempToken?: Maybe<TempToken>;
  previewPublicQuoteRequest?: Maybe<PublicQuoteRequest>;
  viewPublicQuoteRequest?: Maybe<PublicQuoteRequest>;
};


export type QueryFindAccessorialsArgs = {
  filter?: InputMaybe<AccessorialFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindAddressesArgs = {
  filter?: InputMaybe<AddressFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindAddressesForModeArgs = {
  input: FindAddressesForModeInput;
};


export type QueryFindAirportsArgs = {
  filter?: InputMaybe<AirportFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindContactsQuoteRequestsArgs = {
  filter?: InputMaybe<ContactsQuoteRequestsFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindContainersForQuoteRequestArgs = {
  input: FindContainersForQuoteRequestInput;
};


export type QueryFindFilesForQuoteArgs = {
  input: FindFilesForQuoteInput;
};


export type QueryFindPartnersArgs = {
  filter?: InputMaybe<PartnerFilter>;
  orderBy?: InputMaybe<OrderByFilterInput>;
  page?: InputMaybe<PageInput>;
};


export type QueryFindPortsArgs = {
  filter?: InputMaybe<PortFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindQuoteRequestTemplatesArgs = {
  filter?: InputMaybe<QuoteRequestTemplateFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindQuoteRequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<PageRequest>;
};


export type QueryFindStopsForQuoteRequestArgs = {
  input: FindStopsForQuoteRequestInput;
};


export type QueryGet7DayRateBenchmarkArgs = {
  input: Get7DayRateBenchmarkInput;
};


export type QueryGetAirQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryGetAirQuoteTotalsArgs = {
  input: GetAirQuoteTotalsInput;
};


export type QueryGetAirportArgs = {
  id: Scalars['ID'];
};


export type QueryGetBenchmarkFtlArgs = {
  input: GetBenchmarkFtlInput;
};


export type QueryGetContactArgs = {
  id: Scalars['ID'];
};


export type QueryGetFclQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryGetFclQuoteTotalsArgs = {
  input: GetFclQuoteTotalsInput;
};


export type QueryGetLtlLoadSpecTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryGetLtlQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryGetQuoteArgs = {
  id: Scalars['ID'];
};

export type QueryGetQuoteRequestArgs = {
  id: Scalars['ID'];
};


export type QueryGetShipperPartnerTagsArgs = {
  input?: InputMaybe<GetShipperPartnerTagsInput>;
};


export type QueryGetTempTokenArgs = {
  id: Scalars['ID'];
};


export type QueryPreviewPublicQuoteRequestArgs = {
  input?: InputMaybe<PreviewPublicQuoteRequestInput>;
};


export type QueryViewPublicQuoteRequestArgs = {
  input: ViewPublicQuoteRequestInput;
};

/**
 * @db(name: 'quotes')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Quote = Node & {
  __typename?: 'Quote';
  benchmark?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  booking_notes?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  /** @transient */
  conversation_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @transient */
  files: Array<File>;
  id: Scalars['ID'];
  /** @oneToOne(field: 'load', key: 'load_id') */
  load?: Maybe<Load>;
  /** @db(type: 'text') */
  notes?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'quotes', key: 'quote_request_id')
   * @index
   */
  quote_request: QuoteRequest;
  rate_per_load: Scalars['Float'];
  /**
   * @manyToOne(field: 'quotes', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /**
   * @db(type: 'text')
   * @default(value: 'SUBMITTED')
   */
  status: QuoteStatus;
  submitter_email: Scalars['String'];
  submitter_tz?: Maybe<Scalars['String']>;
  total_amount: Scalars['Float'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  valid_until: Scalars['GraphbackDateTime'];
};

export type QuoteChargeTotals = {
  __typename?: 'QuoteChargeTotals';
  customs: Scalars['Float'];
  destination: Scalars['Float'];
  freight: Scalars['Float'];
  insurance: Scalars['Float'];
  origin: Scalars['Float'];
};

export type QuoteContactStatus = {
  __typename?: 'QuoteContactStatus';
  contact?: Maybe<Contact>;
  status?: Maybe<QuoteContactStatusField>;
};

export enum QuoteContactStatusField {
  NotRequested = 'NOT_REQUESTED',
  Pending = 'PENDING',
  Responded = 'RESPONDED'
}

export type QuoteFilter = {
  and?: InputMaybe<Array<QuoteFilter>>;
  benchmark?: InputMaybe<FloatInput>;
  booking_notes?: InputMaybe<StringInput>;
  company_name?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  load_id?: InputMaybe<IdInput>;
  not?: InputMaybe<QuoteFilter>;
  notes?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<QuoteFilter>>;
  quote_request_id?: InputMaybe<IdInput>;
  rate_per_load?: InputMaybe<FloatInput>;
  shipper_id?: InputMaybe<IdInput>;
  status?: InputMaybe<StringInput>;
  submitter_email?: InputMaybe<StringInput>;
  submitter_tz?: InputMaybe<StringInput>;
  total_amount?: InputMaybe<FloatInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  valid_until?: InputMaybe<GraphbackDateTimeInput>;
};

export enum QuoteFrequencyTimeScale {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequest = Node & {
  __typename?: 'QuoteRequest';
  /** @oneToOne(field: 'air_load_spec', key: 'air_load_spec_id') */
  air_load_spec?: Maybe<AirLoadSpec>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  air_quote_charges: Array<AirQuoteCharge>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  air_quotes: Array<AirQuote>;
  /** @oneToOne(field: 'booked_air_quote', key: 'booked_air_quote_id') */
  booked_air_quote?: Maybe<AirQuote>;
  booked_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'quote_requests_booked', key: 'booked_by_id') */
  booked_by?: Maybe<User>;
  /** @oneToOne(field: 'booked_fcl_quote', key: 'booked_fcl_quote_id') */
  booked_fcl_quote?: Maybe<FclQuote>;
  /** @oneToOne(field: 'booked_ltl_quote', key: 'booked_ltl_quote_id') */
  booked_ltl_quote?: Maybe<LtlQuote>;
  /** @oneToOne(field: 'booked_quote', key: 'booked_quote_id') */
  booked_quote?: Maybe<Quote>;
  canceled_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'quote_requests_canceled', key: 'canceled_by_id') */
  canceled_by?: Maybe<User>;
  /** @db(type: 'text') */
  canceled_reason?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  carrier_routing_pref_notes?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'quote_requests_closed', key: 'closed_by_id') */
  closed_by?: Maybe<User>;
  /** @db(type: 'text') */
  closed_reason?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  deadline_respond_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  drayage_load_specs: Array<DrayageLoadSpec>;
  /** @db(length: 10000) */
  email_html_body?: Maybe<Scalars['String']>;
  /** @oneToOne(field: 'fcl_load_spec', key: 'fcl_load_spec_id') */
  fcl_load_spec?: Maybe<FclLoadSpec>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  fcl_quote_charges: Array<FclQuoteCharge>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  fcl_quotes: Array<FclQuote>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  ftl_load_specs: Array<FtlLoadSpec>;
  goods_value?: Maybe<Scalars['Float']>;
  guid?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  insurance_required?: Maybe<Scalars['Boolean']>;
  is_hazardous?: Maybe<Scalars['Boolean']>;
  is_plain_text?: Maybe<Scalars['Boolean']>;
  /** @default(value: false) */
  is_visible?: Maybe<Scalars['Boolean']>;
  /** @oneToOne(field: 'load', key: 'load_id') */
  load?: Maybe<Load>;
  /** @oneToOne(field: 'ltl_load_spec', key: 'ltl_load_spec_id') */
  ltl_load_spec?: Maybe<LtlLoadSpec>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  ltl_quotes: Array<LtlQuote>;
  /** @db(type: 'text') */
  mode: Mode;
  /** @db(type: 'text') */
  note?: Maybe<Scalars['String']>;
  outlook_mode_when_requested?: Maybe<OutlookMode>;
  portex_id?: Maybe<Scalars['String']>;
  /** @manyToOne(field: 'quote_requests', key: 'quote_request_template_id') */
  quote_request_template?: Maybe<QuoteRequestTemplate>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  quotes: Array<Quote>;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  recipients: Array<ContactsQuoteRequests>;
  /** @transient */
  recipients_pending_response: Array<Contact>;
  /** @transient */
  recipients_status_all: Array<QuoteContactStatus>;
  reference_number?: Maybe<Scalars['String']>;
  requested_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @default(value: false) */
  requested_from_web_app?: Maybe<Scalars['Boolean']>;
  /**
   * @manyToOne(field: 'quote_requests', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /**
   * @default(value: 'DRAFT')
   * @db(type: 'text')
   */
  state: QuoteRequestState;
  /** @oneToMany(field: 'quote_request', key: 'quote_request_id') */
  stops: Array<Stop>;
  /**
   * @default(value: 'QUOTE')
   * @db(type: 'text')
   */
  type?: Maybe<RequestType>;
  /**
   * @db(type: 'text')
   * @summary Shipments that have containers require Unloading Details to help the Freight Forwarder understand how the container needs to be unloaded.
   * @see https://portexpro.atlassian.net/browse/POR-2327
   */
  unloading_details?: Maybe<UnloadingDetails>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'quote_requests', key: 'user_id')
   * @index
   */
  user: User;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestAir_Quote_ChargesArgs = {
  filter?: InputMaybe<AirQuoteChargeFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestAir_QuotesArgs = {
  filter?: InputMaybe<AirQuoteFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestDrayage_Load_SpecsArgs = {
  filter?: InputMaybe<DrayageLoadSpecFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestFcl_Quote_ChargesArgs = {
  filter?: InputMaybe<FclQuoteChargeFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestFcl_QuotesArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestFtl_Load_SpecsArgs = {
  filter?: InputMaybe<FtlLoadSpecFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestLtl_QuotesArgs = {
  filter?: InputMaybe<LtlQuoteFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestQuotesArgs = {
  filter?: InputMaybe<QuoteFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestRecipientsArgs = {
  filter?: InputMaybe<ContactsQuoteRequestsFilter>;
};


/**
 * @db(name: 'quote_requests')
 * @model(create: false, find: true, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestStopsArgs = {
  filter?: InputMaybe<StopFilter>;
};

export type QuoteRequestFilter = {
  air_load_spec_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<QuoteRequestFilter>>;
  booked_air_quote_id?: InputMaybe<IdInput>;
  booked_at?: InputMaybe<GraphbackDateTimeInput>;
  booked_by_id?: InputMaybe<IdInput>;
  booked_fcl_quote_id?: InputMaybe<IdInput>;
  booked_ltl_quote_id?: InputMaybe<IdInput>;
  booked_quote_id?: InputMaybe<IdInput>;
  canceled_at?: InputMaybe<GraphbackDateTimeInput>;
  canceled_by_id?: InputMaybe<IdInput>;
  canceled_reason?: InputMaybe<StringInput>;
  carrier_routing_pref_notes?: InputMaybe<StringInput>;
  closed_at?: InputMaybe<GraphbackDateTimeInput>;
  closed_by_id?: InputMaybe<IdInput>;
  closed_reason?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  deadline_respond_at?: InputMaybe<GraphbackDateTimeInput>;
  email_html_body?: InputMaybe<StringInput>;
  fcl_load_spec_id?: InputMaybe<IdInput>;
  goods_value?: InputMaybe<FloatInput>;
  guid?: InputMaybe<StringInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  insurance_required?: InputMaybe<BooleanInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  is_plain_text?: InputMaybe<BooleanInput>;
  is_visible?: InputMaybe<BooleanInput>;
  load_id?: InputMaybe<IdInput>;
  ltl_load_spec_id?: InputMaybe<IdInput>;
  mode?: InputMaybe<StringInput>;
  not?: InputMaybe<QuoteRequestFilter>;
  note?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<QuoteRequestFilter>>;
  outlook_mode_when_requested?: InputMaybe<StringInput>;
  portex_id?: InputMaybe<StringInput>;
  quote_request_template_id?: InputMaybe<IdInput>;
  reference_number?: InputMaybe<StringInput>;
  requested_at?: InputMaybe<GraphbackDateTimeInput>;
  requested_from_web_app?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  state?: InputMaybe<StringInput>;
  type?: InputMaybe<StringInput>;
  unloading_details?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  user_id?: InputMaybe<IdInput>;
};

export type QuoteRequestResultList = {
  __typename?: 'QuoteRequestResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<QuoteRequest>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum QuoteRequestState {
  /** @summary The Shipper booked a quote/fcl_quote/air_quote (booked_quote/booked_fcl_quote/booked_air_quote) for the QuoteRequest */
  Booked = 'BOOKED',
  /**
   * @summary The Shipper has clicked "Cancel Quote" on a "Booked" QuoteRequest or quote in the web app.
   * @description This is a terminal state for a Quote Request that the Shipper wants to cancel. The expected transition for canceling a QuoteRequest is from 'BOOKED' --> 'CANCELED'
   */
  Canceled = 'CANCELED',
  /**
   * @summary The Shipper has clicked "Close Quote" in the web app.
   * @description This is a terminal state for a Quote Request that the Shipper wants to close (e.g. it has been booked off platform).
   */
  Closed = 'CLOSED',
  /** @summary The QuoteRequest has been created, but has not been inserted (or sent) */
  Draft = 'DRAFT',
  /** @summary The QuoteRequest has been inserted into the email in the Outlook Add In (but we do not know if the email was sent) */
  Requested = 'REQUESTED',
  /** @summary quotes/fcl_quotes/air_quotes (at least 1) have come back for the QuoteRequest */
  Returned = 'RETURNED',
  /** @summary The "newQuoteRequest" txn email has been sent via the platform */
  Sent = 'SENT'
}

/**
 * @db(name: 'quote_request_templates')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestTemplate = Node & {
  __typename?: 'QuoteRequestTemplate';
  /** @oneToOne(field: 'air_load_spec_template', key: 'air_load_spec_template_id') */
  air_load_spec_template?: Maybe<AirLoadSpecTemplate>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToMany(field: 'quote_request_template', key: 'quote_request_template_id') */
  drayage_load_spec_templates: Array<DrayageLoadSpecTemplate>;
  /** @oneToOne(field: 'fcl_load_spec_template', key: 'fcl_load_spec_template_id') */
  fcl_load_spec_template?: Maybe<FclLoadSpecTemplate>;
  /** @oneToMany(field: 'quote_request_template', key: 'quote_request_template_id') */
  ftl_load_spec_templates: Array<FtlLoadSpecTemplate>;
  goods_value?: Maybe<Scalars['Float']>;
  /** @db(type: 'text') */
  hazardous_goods_details?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  insurance_required?: Maybe<Scalars['Boolean']>;
  is_hazardous?: Maybe<Scalars['Boolean']>;
  /** @oneToOne(field: 'ltl_load_spec_template', key: 'ltl_load_spec_template_id') */
  ltl_load_spec_template?: Maybe<LtlLoadSpecTemplate>;
  /** @db(type: 'text') */
  mode?: Maybe<Mode>;
  name?: Maybe<Scalars['String']>;
  /** @db(type: 'text') */
  note?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'quote_request_template', key: 'quote_request_template_id') */
  quote_requests: Array<QuoteRequest>;
  /**
   * @manyToOne(field: 'quote_request_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @oneToMany(field: 'quote_request_template', key: 'quote_request_template_id') */
  stop_templates: Array<StopTemplate>;
  /** @db(type: 'text') */
  unloading_details?: Maybe<UnloadingDetails>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @manyToOne(field: 'quote_request_templates', key: 'user_id')
   * @index
   */
  user: User;
};


/**
 * @db(name: 'quote_request_templates')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestTemplateDrayage_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<DrayageLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'quote_request_templates')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestTemplateFtl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<FtlLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'quote_request_templates')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestTemplateQuote_RequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};


/**
 * @db(name: 'quote_request_templates')
 * @model(create: false, find: true, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type QuoteRequestTemplateStop_TemplatesArgs = {
  filter?: InputMaybe<StopTemplateFilter>;
};

export type QuoteRequestTemplateFilter = {
  air_load_spec_template_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<QuoteRequestTemplateFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  fcl_load_spec_template_id?: InputMaybe<IdInput>;
  goods_value?: InputMaybe<FloatInput>;
  hazardous_goods_details?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  insurance_required?: InputMaybe<BooleanInput>;
  is_hazardous?: InputMaybe<BooleanInput>;
  ltl_load_spec_template_id?: InputMaybe<IdInput>;
  mode?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
  not?: InputMaybe<QuoteRequestTemplateFilter>;
  note?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<QuoteRequestTemplateFilter>>;
  shipper_id?: InputMaybe<IdInput>;
  unloading_details?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  user_id?: InputMaybe<IdInput>;
};

export type QuoteRequestTemplateResultList = {
  __typename?: 'QuoteRequestTemplateResultList';
  count?: Maybe<Scalars['Int']>;
  items: Array<Maybe<QuoteRequestTemplate>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum QuoteStatus {
  /**
   * @summary A 'booked' quote status is related to the 'BOOKED' state of a QuoteRequest.
   * @description The expected transition for a QuoteStatus is 'SUBMITTED' --> 'BOOKED'. There should only ever be one booked quote/fcl_quote/air_quote per QuoteRequest.
   */
  Booked = 'BOOKED',
  /**
   * @summary This quote status is related to a booked quote request being canceled.
   * @description The expected transition for a QuoteStatus is 'BOOKED' --> 'CANCELED'. There should only ever be one canceled quote/fcl_quote/air_quote per QuoteRequest.
   */
  Canceled = 'CANCELED',
  /** 'DRAFT' quote status is currently unimplemented */
  Draft = 'DRAFT',
  /**
   * @summary A quote is considered inactive if a submitter inactivates their quote (e.g. re-submitting an FTL quote from the same submitter email)
   * @description The expected transition for a QuoteStatus is 'SUBMITTED' --> 'INACTIVE'
   */
  Inactive = 'INACTIVE',
  /** @summary A 'submitted' quote is considered an active quote */
  Submitted = 'SUBMITTED'
}

export enum QuoteType {
  Additional = 'ADDITIONAL',
  Both = 'BOTH',
  Cheapest = 'CHEAPEST',
  Fastest = 'FASTEST',
  ForwarderPreference = 'FORWARDER_PREFERENCE'
}

export type QuoteTypes = AirQuote | FclQuote | LtlQuote | Quote;

export type ReplaceAccessorialsInput = {
  accessorialIds: Array<Scalars['ID']>;
  ltlLoadSpecId: Scalars['ID'];
};

export enum RequestType {
  Pickup = 'PICKUP',
  Quote = 'QUOTE'
}

export type ResultList = {
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export enum RoutingType {
  D2D = 'D2D',
  D2P = 'D2P',
  P2D = 'P2D',
  P2P = 'P2P'
}

export type SendNewQuoteRequestEmailInput = {
  contactIds?: InputMaybe<Array<Scalars['ID']>>;
  quoteRequestId: Scalars['ID'];
};

export type SendTestEmailInput = {
  email: Scalars['String'];
};

export type SendTransactionalEmailInput = {
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  /** You can also provide a portex_id for this value (e.g. PTX-123456) */
  quoteRequestId?: InputMaybe<Scalars['ID']>;
  quotesIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subject?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeSuffix?: InputMaybe<Scalars['String']>;
};

export type SendTransactionalEmailResult = {
  __typename?: 'SendTransactionalEmailResult';
  bcc: Array<Scalars['String']>;
  cc: Array<Scalars['String']>;
  domain: Scalars['String'];
  from: Scalars['String'];
  html: Scalars['String'];
  replyTo: Scalars['String'];
  subject: Scalars['String'];
  success: Scalars['Boolean'];
  to: Array<Scalars['String']>;
};

export enum ServiceLevel {
  Additional = 'ADDITIONAL',
  Deferred = 'DEFERRED',
  Express = 'EXPRESS',
  ForwarderPreference = 'FORWARDER_PREFERENCE',
  NonStop = 'NON_STOP',
  Standard = 'STANDARD'
}

/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Shipper = Company & Node & {
  __typename?: 'Shipper';
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  accessorials_ltl_load_spec_templates: Array<Maybe<AccessorialsLtlLoadSpecTemplates>>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  accessorials_ltl_load_specs: Array<AccessorialsLtlLoadSpecs>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  address_contacts: Array<AddressContact>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  addresses: Array<Address>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_load_spec_templates: Array<AirLoadSpecTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_load_specs: Array<AirLoadSpec>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_package_group_templates: Array<AirPackageGroupTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_package_groups: Array<AirPackageGroup>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_quote_charges: Array<AirQuoteCharge>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  air_quotes: Array<AirQuote>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  contacts: Array<Contact>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  contacts_quote_requests: Array<ContactsQuoteRequests>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  container_templates: Array<ContainerTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  containers: Array<Container>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  drayage_load_spec_templates: Array<DrayageLoadSpecTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  drayage_load_specs: Array<DrayageLoadSpec>;
  email?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  employees: Array<User>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  fcl_load_spec_templates: Array<FclLoadSpecTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  fcl_load_specs: Array<FclLoadSpec>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  fcl_quote_charges: Array<FclQuoteCharge>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  fcl_quotes: Array<FclQuote>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  files_quotes: Array<FilesQuotes>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  ftl_load_spec_templates: Array<FtlLoadSpecTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  ftl_load_specs: Array<FtlLoadSpec>;
  /** @transient */
  has_made_quote_request?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** @default(value: true) */
  is_active?: Maybe<Scalars['Boolean']>;
  /** @default(value: false) */
  is_internal?: Maybe<Scalars['Boolean']>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  loads: Array<Maybe<Load>>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  ltl_load_spec_templates: Array<LtlLoadSpecTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  ltl_load_specs: Array<LtlLoadSpec>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  ltl_quotes: Array<LtlQuote>;
  name: Scalars['String'];
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  package_group_templates: Array<PackageGroupTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  package_groups: Array<PackageGroup>;
  phone_number?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  quote_request_templates: Array<QuoteRequestTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  quote_requests: Array<QuoteRequest>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  quotes: Array<Quote>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  stop_templates: Array<StopTemplate>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  stops: Array<Stop>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  truck_template: Array<Maybe<TruckTemplate>>;
  /** @oneToMany(field: 'shipper', key: 'shipper_id') */
  trucks: Array<Maybe<Truck>>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAccessorials_Ltl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecTemplatesFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAccessorials_Ltl_Load_SpecsArgs = {
  filter?: InputMaybe<AccessorialsLtlLoadSpecsFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAddress_ContactsArgs = {
  filter?: InputMaybe<AddressContactFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAddressesArgs = {
  filter?: InputMaybe<AddressFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<AirLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_Load_SpecsArgs = {
  filter?: InputMaybe<AirLoadSpecFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_Package_Group_TemplatesArgs = {
  filter?: InputMaybe<AirPackageGroupTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_Package_GroupsArgs = {
  filter?: InputMaybe<AirPackageGroupFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_Quote_ChargesArgs = {
  filter?: InputMaybe<AirQuoteChargeFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperAir_QuotesArgs = {
  filter?: InputMaybe<AirQuoteFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperContacts_Quote_RequestsArgs = {
  filter?: InputMaybe<ContactsQuoteRequestsFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperContainer_TemplatesArgs = {
  filter?: InputMaybe<ContainerTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperContainersArgs = {
  filter?: InputMaybe<ContainerFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperDrayage_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<DrayageLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperDrayage_Load_SpecsArgs = {
  filter?: InputMaybe<DrayageLoadSpecFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperEmployeesArgs = {
  filter?: InputMaybe<UserFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFcl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<FclLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFcl_Load_SpecsArgs = {
  filter?: InputMaybe<FclLoadSpecFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFcl_Quote_ChargesArgs = {
  filter?: InputMaybe<FclQuoteChargeFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFcl_QuotesArgs = {
  filter?: InputMaybe<FclQuoteFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFiles_QuotesArgs = {
  filter?: InputMaybe<FilesQuotesFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFtl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<FtlLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperFtl_Load_SpecsArgs = {
  filter?: InputMaybe<FtlLoadSpecFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperLoadsArgs = {
  filter?: InputMaybe<LoadFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperLtl_Load_Spec_TemplatesArgs = {
  filter?: InputMaybe<LtlLoadSpecTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperLtl_Load_SpecsArgs = {
  filter?: InputMaybe<LtlLoadSpecFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperLtl_QuotesArgs = {
  filter?: InputMaybe<LtlQuoteFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperPackage_Group_TemplatesArgs = {
  filter?: InputMaybe<PackageGroupTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperPackage_GroupsArgs = {
  filter?: InputMaybe<PackageGroupFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperQuote_Request_TemplatesArgs = {
  filter?: InputMaybe<QuoteRequestTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperQuote_RequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperQuotesArgs = {
  filter?: InputMaybe<QuoteFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperStop_TemplatesArgs = {
  filter?: InputMaybe<StopTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperStopsArgs = {
  filter?: InputMaybe<StopFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperTruck_TemplateArgs = {
  filter?: InputMaybe<TruckTemplateFilter>;
};


/**
 * @db(name: 'shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type ShipperTrucksArgs = {
  filter?: InputMaybe<TruckFilter>;
};

/**
 * @db(name: 'signup_survey_shippers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type SignupSurveyShipper = Node & {
  __typename?: 'SignupSurveyShipper';
  created_at: Scalars['GraphbackDateTime'];
  id: Scalars['ID'];
  /** @default(value: false) */
  mode_air: Scalars['Boolean'];
  /** @default(value: false) */
  mode_fcl: Scalars['Boolean'];
  /** @default(value: false) */
  mode_ftl: Scalars['Boolean'];
  partner_count: PartnerCount;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @oneToOne(field: 'user', key: 'user_id')
   * @unique
   */
  user: User;
  /** @default(value: 'MODE_VOLUME_0') */
  volume_air: ModeVolume;
  /** @default(value: 'MODE_VOLUME_0') */
  volume_fcl: ModeVolume;
  /** @default(value: 'MODE_VOLUME_0') */
  volume_ftl: ModeVolume;
};

export type SoftDeletable = {
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  deleted_by?: Maybe<User>;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortDirectionFilterEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * @db(name: 'stops')
 * @model(create: true, find: false, findOne: false, update: true, delete: true, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Stop = Node & {
  __typename?: 'Stop';
  /**
   * @manyToOne(field: 'stops', key: 'address_id')
   * @index
   */
  address?: Maybe<Address>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  distance_from_prior_stop?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  is_na?: Maybe<Scalars['Boolean']>;
  /** @default(value: false) */
  is_time_tbd?: Maybe<Scalars['Boolean']>;
  /** @db(type: 'text') */
  note?: Maybe<Scalars['String']>;
  /** @unique(name: 'quote_request_position_unique') */
  position: Scalars['Int'];
  /**
   * @manyToOne(field: 'stops', key: 'quote_request_id')
   * @unique(name: 'quote_request_position_unique')
   */
  quote_request: QuoteRequest;
  reference_number?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'stops', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  start?: Maybe<Scalars['GraphbackDateTime']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type StopAddressPayload = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  address_contacts?: InputMaybe<Array<AddressContactPayload>>;
  airport_iata_code?: InputMaybe<Scalars['String']>;
  airport_id?: InputMaybe<Scalars['String']>;
  airport_name?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  country_name?: InputMaybe<Scalars['String']>;
  google_place_description?: InputMaybe<Scalars['String']>;
  google_place_id?: InputMaybe<Scalars['String']>;
  hours_end?: InputMaybe<Scalars['GraphbackDateTime']>;
  hours_start?: InputMaybe<Scalars['GraphbackDateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  port_id?: InputMaybe<Scalars['String']>;
  port_name?: InputMaybe<Scalars['String']>;
  province_code?: InputMaybe<Scalars['String']>;
  province_name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
  zip?: InputMaybe<Scalars['String']>;
};

export type StopFilter = {
  address_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<StopFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  distance_from_prior_stop?: InputMaybe<IntInput>;
  end?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  is_na?: InputMaybe<BooleanInput>;
  is_time_tbd?: InputMaybe<BooleanInput>;
  not?: InputMaybe<StopFilter>;
  note?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<StopFilter>>;
  position?: InputMaybe<IntInput>;
  quote_request_id?: InputMaybe<IdInput>;
  reference_number?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  start?: InputMaybe<GraphbackDateTimeInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type StopImpersonationInput = {
  switchTo?: InputMaybe<SwitchShipperEnum>;
};

export type StopPayload = {
  address?: InputMaybe<StopAddressPayload>;
  end?: InputMaybe<Scalars['GraphbackDateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  is_na?: InputMaybe<Scalars['Boolean']>;
  is_time_tbd?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reference_number?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type StopPayloadForRoutingDetails = {
  address?: InputMaybe<StopAddressPayload>;
  position: Scalars['Int'];
};

/**
 * @db(name: 'stop_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type StopTemplate = Node & {
  __typename?: 'StopTemplate';
  /**
   * @manyToOne(field: 'stop_templates', key: 'address_id')
   * @index
   */
  address?: Maybe<Address>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @db(type: 'text') */
  note?: Maybe<Scalars['String']>;
  /** @unique(name: 'quote_request_template_position_unique') */
  position: Scalars['Int'];
  /**
   * @manyToOne(field: 'stop_templates', key: 'quote_request_template_id')
   * @unique(name: 'quote_request_template_position_unique')
   */
  quote_request_template: QuoteRequestTemplate;
  /**
   * @manyToOne(field: 'stop_templates', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type StopTemplateFilter = {
  address_id?: InputMaybe<IdInput>;
  and?: InputMaybe<Array<StopTemplateFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  id?: InputMaybe<IdInput>;
  not?: InputMaybe<StopTemplateFilter>;
  note?: InputMaybe<StringInput>;
  or?: InputMaybe<Array<StopTemplateFilter>>;
  position?: InputMaybe<IntInput>;
  quote_request_template_id?: InputMaybe<IdInput>;
  shipper_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
};

export type StringInput = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  ge?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  le?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type SubmitAirQuoteInput = {
  carrier?: InputMaybe<Scalars['String']>;
  destination_airport: AirQuoteAirportPayload;
  dim_factor: Scalars['Float'];
  max_transit_time: Scalars['Int'];
  min_transit_time: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  notes_charges_insurance?: InputMaybe<Scalars['String']>;
  notes_charges_miscellaneous?: InputMaybe<Scalars['String']>;
  origin_airport: AirQuoteAirportPayload;
  quote_charges: Array<AirQuoteChargePayload>;
  service_level: ServiceLevel;
  submitter_email: Scalars['String'];
  submitter_tz?: InputMaybe<Scalars['String']>;
  valid_until: Scalars['GraphbackDateTime'];
  via_airport?: InputMaybe<AirQuoteAirportPayload>;
  volumetric_weight: Scalars['Float'];
};

export type SubmitFclQuoteInput = {
  capacity_guarantee: Scalars['Boolean'];
  carrier?: InputMaybe<Scalars['String']>;
  destination_port: FclQuotePortPayload;
  destination_rail_ramp?: InputMaybe<FclQuotePortPayload>;
  inland_mode_of_transport?: InputMaybe<InlandModeOfTransportType>;
  max_transit_time: Scalars['Int'];
  min_transit_time: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  notes_charges_insurance?: InputMaybe<Scalars['String']>;
  notes_charges_miscellaneous?: InputMaybe<Scalars['String']>;
  origin_port: FclQuotePortPayload;
  quote_charges: Array<FclQuoteChargePayload>;
  submitter_email: Scalars['String'];
  submitter_tz?: InputMaybe<Scalars['String']>;
  type: QuoteType;
  valid_until: Scalars['GraphbackDateTime'];
  via_port?: InputMaybe<FclQuotePortPayload>;
};

export type SubmitLtlQuoteInput = {
  carrier_name: Scalars['String'];
  company_name?: InputMaybe<Scalars['String']>;
  max_transit_time?: InputMaybe<Scalars['Int']>;
  min_transit_time?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  quote_request_guid: Scalars['String'];
  submitter_email: Scalars['String'];
  submitter_tz?: InputMaybe<Scalars['String']>;
  total_amount: Scalars['Float'];
  valid_until: Scalars['GraphbackDateTime'];
};

export type SubmitQuoteInput = {
  company_name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quote_request_guid: Scalars['String'];
  rate_per_load: Scalars['Float'];
  submitter_email: Scalars['String'];
  submitter_tz?: InputMaybe<Scalars['String']>;
  valid_until: Scalars['GraphbackDateTime'];
};

export type SubmitQuoteRequestInput = {
  email_html_body?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  outlook_mode_when_requested?: InputMaybe<OutlookMode>;
};

export enum SwitchShipperEnum {
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Test = 'TEST'
}

export type SwitchShipperInput = {
  switchTo: SwitchShipperEnum;
};

export type Tag = Node & SoftDeletable & {
  __typename?: 'Tag';
  /** config is a computed field, not in the DB */
  config?: Maybe<TagConfig>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  deleted_at?: Maybe<Scalars['GraphbackDateTime']>;
  deleted_by?: Maybe<User>;
  id: Scalars['ID'];
  tag: Scalars['String'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type TagConfig = {
  __typename?: 'TagConfig';
  color: Scalars['String'];
  group: Scalars['Int'];
};

/**
 * @db(name: 'temp_tokens')
 * @model(create: false, find: false, findOne: true, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type TempToken = Node & {
  __typename?: 'TempToken';
  company_id?: Maybe<Scalars['ID']>;
  company_type?: Maybe<CompanyType>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  email_to_verify?: Maybe<Scalars['String']>;
  expires_at: Scalars['GraphbackDateTime'];
  /** @unique */
  guid: Scalars['String'];
  id: Scalars['ID'];
  /** @default(value: false) */
  is_single_use?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_valid?: Maybe<Scalars['Boolean']>;
  /**
   * ------
   * ------ end temp token type specific fields ------
   * ------
   */
  last_used_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * ------
   * ------ begin temp token type specific fields ------
   * ------
   */
  quote_request_guid?: Maybe<Scalars['String']>;
  signup_email?: Maybe<Scalars['String']>;
  type: TempTokenType;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export enum TempTokenType {
  EmailVerification = 'EMAIL_VERIFICATION',
  Resource = 'RESOURCE',
  Signup = 'SIGNUP'
}

export enum TempUnit {
  C = 'C',
  F = 'F'
}

export enum TrailerSize {
  T_26 = 'T_26',
  T_40 = 'T_40',
  T_48 = 'T_48',
  T_53 = 'T_53',
  C_20 = 'C_20',
  C_40 = 'C_40',
  C_20Hc = 'C_20_HC',
  C_40Hc = 'C_40_HC',
  C_45Hc = 'C_45_HC',
  Na = 'NA'
}

/**
 * @db(name: 'transportation_providers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type TransportationProvider = Company & Node & {
  __typename?: 'TransportationProvider';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  email?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'transportation_provider', key: 'transportation_provider_id') */
  employees: Array<User>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};


/**
 * @db(name: 'transportation_providers')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type TransportationProviderEmployeesArgs = {
  filter?: InputMaybe<UserFilter>;
};

/**
 * @db(name: 'trucks')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type Truck = Node & {
  __typename?: 'Truck';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @manyToOne(field: 'trucks', key: 'ftl_load_spec_id') */
  ftl_load_spec?: Maybe<FtlLoadSpec>;
  id: Scalars['ID'];
  /** @oneToOne(field: 'ltl_load_spec', key: 'ltl_load_spec_id') */
  ltl_load_spec?: Maybe<LtlLoadSpec>;
  /** @db(type: 'text') */
  reference_number?: Maybe<Scalars['String']>;
  /**
   * @manyToOne(field: 'trucks', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @db(type: 'text') */
  trailer_size?: Maybe<TrailerSize>;
  /** @db(type: 'text') */
  trailer_type?: Maybe<FtlTrailerType>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type TruckFilter = {
  and?: InputMaybe<Array<TruckFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  ftl_load_spec_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  ltl_load_spec_id?: InputMaybe<IdInput>;
  not?: InputMaybe<TruckFilter>;
  or?: InputMaybe<Array<TruckFilter>>;
  reference_number?: InputMaybe<StringInput>;
  shipper_id?: InputMaybe<IdInput>;
  trailer_size?: InputMaybe<StringInput>;
  trailer_type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @db(name: 'truck_templates')
 * @model(create: false, find: false, findOne: false, update: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type TruckTemplate = Node & {
  __typename?: 'TruckTemplate';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToOne(field: 'ftl_load_spec_template_id', key: 'ftl_load_spec_template_id') */
  ftl_load_spec_template?: Maybe<FtlLoadSpecTemplate>;
  id: Scalars['ID'];
  /** @oneToOne(field: 'ltl_load_spec_template_id', key: 'ltl_load_spec_template_id') */
  ltl_load_spec_template?: Maybe<LtlLoadSpecTemplate>;
  /**
   * @manyToOne(field: 'truck_template', key: 'shipper_id')
   * @index
   */
  shipper: Shipper;
  /** @db(type: 'text') */
  trailer_size?: Maybe<TrailerSize>;
  /** @db(type: 'text') */
  trailer_type?: Maybe<FtlTrailerType>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
};

export type TruckTemplateFilter = {
  and?: InputMaybe<Array<TruckTemplateFilter>>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  ftl_load_spec_template_id?: InputMaybe<IdInput>;
  id?: InputMaybe<IdInput>;
  ltl_load_spec_template_id?: InputMaybe<IdInput>;
  not?: InputMaybe<TruckTemplateFilter>;
  or?: InputMaybe<Array<TruckTemplateFilter>>;
  shipper_id?: InputMaybe<IdInput>;
  trailer_size?: InputMaybe<StringInput>;
  trailer_type?: InputMaybe<StringInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
};

/**
 * @description Containers require Unloading Details to help the Freight Forwarder understand wether or not the container needs to be unloaded by hand (Live Unload) or just dropped off at the destination - where the trucker may pick up a different empty container to bring back to the port (Drop & Pick) or they may come back later to pick up the container after it has been unloaded (potentially a few days later - this is called a Drop).
 * @see https://portexpro.atlassian.net/browse/POR-2327
 */
export enum UnloadingDetails {
  /**
   * @summary This is actually "Drop and Pick" not just "Drop"
   * @example "Drop and Pick"
   * @description This means that the FF needs to tell the trucker to drop off the container at the destination and pick up another container to bring back to the port.
   * @see https://www.flexport.com/glossary/drop-and-pick/#:~:text=A%20drop%20and%20pick%20is%20when%20the%20truck%20driver%20drops,containers%20arriving%20every%20few%20days.
   */
  Drop = 'DROP',
  /**
   * @description This means that the FF needs to pay the truck driver an hourly fee to wait for the container to be unloaded. The truck driver is not unloading the container, but they must wait at the destination until the container is unloaded so that they can bring the container back to the port. This is important because the Port will charge the truck driver, who will then charge the FF, who will then charge the shipper a daily fee that the container is not at the port (called a detention fee).
   * @example "Live Unload"
   * @see https://www.container-xchange.com/blog/chassis-charges-and-soc/#:~:text=Chassis%20Surcharge%20Explained,-Chassis%20is%20used&text=It%20can%20typically%20range%20from,is%20demurrage%20and%20detention%20fees.
   * @see https://www.flexport.com/help/34-trucking-fees-fcl/
   */
  Live = 'LIVE'
}

export type UpdateAddressLabelInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCargoDetailsInput = {
  /** Required -- must be included */
  airPackageGroups?: InputMaybe<Array<AirPackageGroupPayload>>;
  /** @deprecated(reason: "Old feature that is no longer supported") */
  cargoDetails?: InputMaybe<CargoDetailsAir>;
  quoteRequestId: Scalars['ID'];
  /** @deprecated(reason: "Old feature -- must always be true") */
  useAirPackageGroups: Scalars['Boolean'];
};

export type UpdateContainersForQuoteRequestInput = {
  containers: Array<ContainerPayload>;
  quote_request_id: Scalars['ID'];
};

export type UpdatePartnerInput = {
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateQuoteRequestInput = {
  carrier_routing_pref_notes?: InputMaybe<Scalars['String']>;
  deadline_respond_at?: InputMaybe<Scalars['GraphbackDateTime']>;
  email_html_body?: InputMaybe<Scalars['String']>;
  goods_value?: InputMaybe<Scalars['Float']>;
  hazardous_goods_details?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  insurance_required?: InputMaybe<Scalars['Boolean']>;
  is_hazardous?: InputMaybe<Scalars['Boolean']>;
  is_plain_text?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reference_number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<RequestType>;
  unloading_details?: InputMaybe<UnloadingDetails>;
};

export type UpdateQuoteRequestQuoteTypesInput = {
  airServiceLevel?: InputMaybe<Array<ServiceLevel>>;
  carrierRoutingPrefNotes?: InputMaybe<Scalars['String']>;
  fclCapacityGuarenteeRequired?: InputMaybe<Scalars['Boolean']>;
  fclDirectSailingRequired?: InputMaybe<Scalars['Boolean']>;
  fclQuoteTypes?: InputMaybe<Array<QuoteType>>;
  id: Scalars['ID'];
};

export type UpdateQuoteRequestRecipientsInput = {
  quoteRequestId: Scalars['ID'];
  recipientIds: Array<Scalars['ID']>;
};

export type UpdateQuoteRequestRoutingDetailsInput = {
  airIncoterms?: InputMaybe<AirIncoterms>;
  cargo_ready_date: Scalars['GraphbackDateTime'];
  carrierRoutingPrefNotes?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mode: Mode;
  oceanIncoterms?: InputMaybe<OceanIncoterms>;
  routing_type: RoutingType;
  stops: Array<StopPayloadForRoutingDetails>;
  target_delivery_date?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type UpdateQuoteRequestRoutingInput = {
  quoteRequestId: Scalars['ID'];
  routingType: RoutingType;
};

export type UpdateQuoteRequestWeightUnitInput = {
  quoteRequestId: Scalars['ID'];
  weightUnit: WeightUnit;
};

export type UpdateSelfInput = {
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
};

export type UpdateStopDetailsInput = {
  stop: UpdateStopDetailsPayload;
};

export type UpdateStopDetailsPayload = {
  address?: InputMaybe<StopAddressPayload>;
  end?: InputMaybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  is_na?: InputMaybe<Scalars['Boolean']>;
  is_time_tbd?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reference_number?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['GraphbackDateTime']>;
};

export type UpdateStopsForQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
  stops: Array<StopPayload>;
};

export type UpdateTeamMemberInput = {
  city?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateTruckInput = {
  id: Scalars['ID'];
  reference_number?: InputMaybe<Scalars['String']>;
};

/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type User = Node & {
  __typename?: 'User';
  /** @unique */
  auth_0_user_id?: Maybe<Scalars['String']>;
  /** @oneToMany(field: 'user', key: 'user_id') */
  contacts: Array<Contact>;
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToMany(field: 'deleted_by', key: 'deleted_by_id') */
  deleted_addresses: Array<Address>;
  /** @oneToMany(field: 'deleted_by', key: 'deleted_by_id') */
  deleted_contacts: Array<Contact>;
  /** @oneToMany(field: 'deleted_by', key: 'deleted_by_id') */
  deleted_files: Array<File>;
  /** @oneToMany(field: 'deleted_by', key: 'deleted_by_id') */
  deleted_loads: Array<Load>;
  /** @unique */
  email: Scalars['String'];
  /** @transient */
  feature_flag_demo: Scalars['Boolean'];
  /** @transient */
  feature_flag_internal: Scalars['Boolean'];
  /** @oneToMany(field: 'created_by', key: 'created_by_id') */
  files: Array<File>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  impersonating?: Maybe<Scalars['Boolean']>;
  /** @default(value: true) */
  is_active?: Maybe<Scalars['Boolean']>;
  job_title?: Maybe<Scalars['String']>;
  last_action_at?: Maybe<Scalars['GraphbackDateTime']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  /** @default(value: false) */
  portex_admin?: Maybe<Scalars['Boolean']>;
  /** @default(value: false) */
  portex_super_admin?: Maybe<Scalars['Boolean']>;
  /** @oneToMany(field: 'user', key: 'user_id') */
  quote_request_templates: Array<QuoteRequestTemplate>;
  /** @oneToMany(field: 'user', key: 'user_id') */
  quote_requests: Array<QuoteRequest>;
  /** @oneToMany(field: 'booked_by', key: 'booked_by_id') */
  quote_requests_booked: Array<QuoteRequest>;
  /** @oneToMany(field: 'canceled_by', key: 'canceled_by_id') */
  quote_requests_canceled: Array<QuoteRequest>;
  /** @oneToMany(field: 'closed_by', key: 'closed_by_id') */
  quote_requests_closed: Array<QuoteRequest>;
  /** @manyToOne(field: 'employees', key: 'shipper_id') */
  shipper?: Maybe<Shipper>;
  /** @manyToOne(field: 'employees', key: 'transportation_provider_id') */
  transportation_provider?: Maybe<TransportationProvider>;
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /** @oneToOne(field: 'user_default', key: 'user_default_id') */
  user_default?: Maybe<UserDefault>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserDeleted_AddressesArgs = {
  filter?: InputMaybe<AddressFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserDeleted_ContactsArgs = {
  filter?: InputMaybe<ContactFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserDeleted_FilesArgs = {
  filter?: InputMaybe<FileFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserDeleted_LoadsArgs = {
  filter?: InputMaybe<LoadFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserFilesArgs = {
  filter?: InputMaybe<FileFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserQuote_Request_TemplatesArgs = {
  filter?: InputMaybe<QuoteRequestTemplateFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserQuote_RequestsArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserQuote_Requests_BookedArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserQuote_Requests_CanceledArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};


/**
 * @db(name: 'users')
 * @model(create: false, update: false, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserQuote_Requests_ClosedArgs = {
  filter?: InputMaybe<QuoteRequestFilter>;
};

/**
 * @db(name: 'user_defaults')
 * @model(create: false, update: true, find: false, findOne: false, delete: false, subCreate: false, subUpdate: false, subDelete: false)
 */
export type UserDefault = Node & {
  __typename?: 'UserDefault';
  created_at?: Maybe<Scalars['GraphbackDateTime']>;
  id: Scalars['ID'];
  /** @default(value: false) */
  per_truck_notes: Scalars['Boolean'];
  /**
   * @default(value: false)
   * @deprecated Old feature that is no longer supported
   */
  plain_text_email: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['GraphbackDateTime']>;
  /**
   * @unique
   * @oneToOne(field: 'user', key: 'user_id')
   */
  user: User;
};

export type UserFilter = {
  and?: InputMaybe<Array<UserFilter>>;
  auth_0_user_id?: InputMaybe<StringInput>;
  created_at?: InputMaybe<GraphbackDateTimeInput>;
  email?: InputMaybe<StringInput>;
  first_name?: InputMaybe<StringInput>;
  id?: InputMaybe<IdInput>;
  impersonating?: InputMaybe<BooleanInput>;
  is_active?: InputMaybe<BooleanInput>;
  job_title?: InputMaybe<StringInput>;
  last_action_at?: InputMaybe<GraphbackDateTimeInput>;
  last_name?: InputMaybe<StringInput>;
  not?: InputMaybe<UserFilter>;
  or?: InputMaybe<Array<UserFilter>>;
  phone_number?: InputMaybe<StringInput>;
  portex_admin?: InputMaybe<BooleanInput>;
  portex_super_admin?: InputMaybe<BooleanInput>;
  shipper_id?: InputMaybe<IdInput>;
  transportation_provider_id?: InputMaybe<IdInput>;
  updated_at?: InputMaybe<GraphbackDateTimeInput>;
  user_default_id?: InputMaybe<IdInput>;
};

export type ViewPublicQuoteRequestInput = {
  quoteRequestId: Scalars['ID'];
};

export enum VolumeFormat {
  Dimensions = 'DIMENSIONS',
  Volume = 'VOLUME'
}

export enum WeightUnit {
  Kg = 'KG',
  Lb = 'LB'
}
